// -- (function(scope){
// -- 'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.iO.cz === region.fw.cz)
	{
		return 'on line ' + region.iO.cz;
	}
	return 'on lines ' + region.iO.cz + ' through ' + region.fw.cz;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.h$,
		impl.i4,
		impl.gT,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


/*
function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/


/*
function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}

*/

/*
function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}
*/




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		h9: func(record.h9),
		iS: record.iS,
		iw: record.iw
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.h9;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.iS;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.iw) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.h$,
		impl.i4,
		impl.gT,
		function(sendToApp, initialModel) {
			var view = impl.i6;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.h$,
		impl.i4,
		impl.gT,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.eR && impl.eR(sendToApp)
			var view = impl.i6;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fh);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.iY) && (_VirtualDom_doc.title = title = doc.iY);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.ir;
	var onUrlRequest = impl.is;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		eR: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.gt === next.gt
							&& curr.fI === next.fI
							&& curr.gp.a === next.gp.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		h$: function(flags)
		{
			return A3(impl.h$, flags, _Browser_getUrl(), key);
		},
		i6: impl.i6,
		i4: impl.i4,
		gT: impl.gT
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hY: 'hidden', hw: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hY: 'mozHidden', hw: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hY: 'msHidden', hw: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hY: 'webkitHidden', hw: 'webkitvisibilitychange' }
		: { hY: 'hidden', hw: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		gG: _Browser_getScene(),
		g5: {
			hb: _Browser_window.pageXOffset,
			hc: _Browser_window.pageYOffset,
			bn: _Browser_doc.documentElement.clientWidth,
			au: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bn: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		au: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			gG: {
				bn: node.scrollWidth,
				au: node.scrollHeight
			},
			g5: {
				hb: node.scrollLeft,
				hc: node.scrollTop,
				bn: node.clientWidth,
				au: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			gG: _Browser_getScene(),
			g5: {
				hb: x,
				hc: y,
				bn: _Browser_doc.documentElement.clientWidth,
				au: _Browser_doc.documentElement.clientHeight
			},
			hN: {
				hb: x + rect.left,
				hc: y + rect.top,
				bn: rect.width,
				au: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.fz.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.fz.b, xhr)); });
		$elm$core$Maybe$isJust(request.g_) && _Http_track(router, xhr, request.g_.a);

		try {
			xhr.open(request.f2, request.g3, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.g3));
		}

		_Http_configureRequest(xhr, request);

		request.fh.a && xhr.setRequestHeader('Content-Type', request.fh.a);
		xhr.send(request.fh.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.fH; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.gX.a || 0;
	xhr.responseType = request.fz.d;
	xhr.withCredentials = request.hi;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		g3: xhr.responseURL,
		iP: xhr.status,
		iQ: xhr.statusText,
		fH: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			iL: event.loaded,
			gL: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			iy: event.loaded,
			gL: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}



// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.ie) { flags += 'm'; }
	if (options.hu) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $author$project$Plans$ValidModel = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.y) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.B),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.B);
		} else {
			var treeLen = builder.y * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.F) : builder.F;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.y);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.B) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.B);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{F: nodeList, y: (len / $elm$core$Array$branchFactor) | 0, B: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fD: fragment, fI: host, gm: path, gp: port_, gt: protocol, gu: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Plans$Editable = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Plans$PlanPositionDetected = function (a) {
	return {$: 13, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$core$Basics$round = _Basics_round;
var $author$project$Position$elementsPosition = function (_v0) {
	var element = _v0.hN;
	return {
		hb: $elm$core$Basics$round(element.hb),
		hc: $elm$core$Basics$round(element.hc)
	};
};
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Plans$planId = 'elm-plan';
var $author$project$Plans$getPlanPageCoordinates = A2(
	$elm$core$Task$attempt,
	$author$project$Plans$PlanPositionDetected,
	A2(
		$elm$core$Task$map,
		$author$project$Position$elementsPosition,
		$elm$browser$Browser$Dom$getElement($author$project$Plans$planId)));
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$monitorResize = _Platform_outgoingPort('monitorResize', $elm$json$Json$Encode$string);
var $author$project$Plans$cmdsWhenPlanOpened = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[
			$author$project$Plans$getPlanPageCoordinates,
			$author$project$Ports$monitorResize($author$project$Plans$planId)
		]));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Plans$PFP = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plans$PersistedFloorPlan = F6(
	function (id, name, image, physicalLocations, updateRequest, provisionalPhysicalLocations) {
		return {fM: id, T: image, f9: name, K: physicalLocations, U: provisionalPhysicalLocations, cY: updateRequest};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Plans$imageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'height',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'width',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed(
				F3(
					function (url, w, h) {
						return {au: h, g3: url, bn: w};
					})))));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Plans$DataSeries = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Plans$Name = $elm$core$Basics$identity;
var $author$project$Plans$BinaryDataPoint = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Plans$binaryDataPointDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'last_binary_value',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	$elm$json$Json$Decode$succeed($author$project$Plans$BinaryDataPoint));
var $author$project$Plans$NumericDataPoint = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Plans$numericDataPointDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unit',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'last_numeric_value',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Plans$NumericDataPoint)));
var $author$project$Plans$dataPointDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Plans$numericDataPointDecoder, $author$project$Plans$binaryDataPointDecoder]));
var $author$project$Plans$dataSeriesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Plans$dataPointDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Plans$DataSeries))));
var $author$project$Plans$Meter = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Enectiva$Conversion$decodeResult = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$json$Json$Decode$succeed(a);
	} else {
		var err = result.a;
		return $elm$json$Json$Decode$fail(err);
	}
};
var $author$project$Types$Co = 5;
var $author$project$Types$El = 1;
var $author$project$Types$Ga = 2;
var $author$project$Types$Hca = 6;
var $author$project$Types$He = 4;
var $author$project$Types$Lf = 7;
var $author$project$Types$Wa = 3;
var $author$project$Types$energyFromString = function (str) {
	switch (str) {
		case 'el':
			return $elm$core$Result$Ok(1);
		case 'ga':
			return $elm$core$Result$Ok(2);
		case 'wa':
			return $elm$core$Result$Ok(3);
		case 'he':
			return $elm$core$Result$Ok(4);
		case 'co':
			return $elm$core$Result$Ok(5);
		case 'hca':
			return $elm$core$Result$Ok(6);
		case 'lf':
			return $elm$core$Result$Ok(7);
		default:
			return $elm$core$Result$Err('unknown energy ' + str);
	}
};
var $author$project$Types$energyDecoder = A3(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$map($author$project$Types$energyFromString),
	$elm$json$Json$Decode$andThen($author$project$Enectiva$Conversion$decodeResult),
	$elm$json$Json$Decode$string);
var $author$project$Plans$meterDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'energy',
	$author$project$Types$energyDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Plans$Meter))));
var $author$project$Plans$objectDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'meter', $author$project$Plans$meterDecoder),
			A2($elm$json$Json$Decode$field, 'data_series', $author$project$Plans$dataSeriesDecoder)
		]));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Position$Position = F2(
	function (x, y) {
		return {hb: x, hc: y};
	});
var $author$project$Position$positionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'y',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'x',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Position$Position)));
var $author$project$Plans$physicalLocationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Plans$objectDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'position',
		$author$project$Position$positionDecoder,
		$elm$json$Json$Decode$succeed($elm$core$Tuple$pair)));
var $author$project$Enectiva$ValidatedValue$NotValidated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Enectiva$ValidatedValue$init = function (v) {
	return $author$project$Enectiva$ValidatedValue$NotValidated(v);
};
var $author$project$Enectiva$ValidatedValue$stringDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Enectiva$ValidatedValue$init(s));
	},
	$elm$json$Json$Decode$string);
var $author$project$Plans$floorPlanDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Plans$PFP,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		_List_Nil,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'physicalLocations',
				$elm$json$Json$Decode$list($author$project$Plans$physicalLocationDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'image',
					$author$project$Plans$imageDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$author$project$Enectiva$ValidatedValue$stringDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Plans$PersistedFloorPlan))))))));
var $author$project$Plans$FloorPlanDropped = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Plans$FlorPlanDnDMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$DnD$ignoreDropPosition = function (tagger) {
	return F3(
		function (drop, drag, _v0) {
			return A2(tagger, drop, drag);
		});
};
var $author$project$DnD$Draggable = $elm$core$Basics$identity;
var $author$project$DnD$DragStart = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$DnD$MousePosition = F2(
	function (x, y) {
		return {hb: x, hc: y};
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$DnD$pageX = A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$int);
var $author$project$DnD$pageY = A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$int);
var $author$project$DnD$draggable = F4(
	function (wrap, meta, attrs, html) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Events$custom,
						'mousedown',
						A2(
							$elm$json$Json$Decode$map,
							function (m) {
								return {h9: m, iw: true, iS: true};
							},
							A2(
								$elm$json$Json$Decode$map,
								A2(
									$elm$core$Basics$composeL,
									wrap,
									$author$project$DnD$DragStart(meta)),
								A3($elm$json$Json$Decode$map2, $author$project$DnD$MousePosition, $author$project$DnD$pageX, $author$project$DnD$pageY))))
					]),
				attrs),
			html);
	});
var $author$project$DnD$EnterDroppable = function (a) {
	return {$: 3, a: a};
};
var $author$project$DnD$LeaveDroppable = {$: 4};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$DnD$droppable = F4(
	function (wrap, dropMeta, attrs, html) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				attrs,
				_List_fromArray(
					[
						$elm$html$Html$Events$onMouseEnter(
						wrap(
							$author$project$DnD$EnterDroppable(dropMeta))),
						$elm$html$Html$Events$onMouseLeave(
						wrap($author$project$DnD$LeaveDroppable))
					])),
			html);
	});
var $author$project$DnD$DragEnd = function (a) {
	return {$: 2, a: a};
};
var $author$project$DnD$Dragging = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {go: pids, gS: subs};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {fy: event, fV: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.go,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.fV;
		var event = _v0.fy;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.gS);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, 0, 'mousemove');
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $author$project$DnD$subscriptions = F3(
	function (wrap, onDrop, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return $elm$core$Platform$Sub$none;
		} else {
			var drag = model.a;
			var _v2 = drag.co;
			if (!_v2.$) {
				var dropMeta = _v2.a;
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$elm$browser$Browser$Events$onMouseMove(
							A2(
								$elm$json$Json$Decode$map,
								wrap,
								A2(
									$elm$json$Json$Decode$map,
									$author$project$DnD$Dragging,
									A3($elm$json$Json$Decode$map2, $author$project$DnD$MousePosition, $author$project$DnD$pageX, $author$project$DnD$pageY)))),
							$elm$browser$Browser$Events$onMouseUp(
							A2(
								$elm$json$Json$Decode$map,
								A2(onDrop, dropMeta, drag.c8),
								A3($elm$json$Json$Decode$map2, $author$project$DnD$MousePosition, $author$project$DnD$pageX, $author$project$DnD$pageY))),
							$elm$browser$Browser$Events$onMouseUp(
							A2(
								$elm$json$Json$Decode$map,
								wrap,
								A2(
									$elm$json$Json$Decode$map,
									$author$project$DnD$DragEnd,
									A3($elm$json$Json$Decode$map2, $author$project$DnD$MousePosition, $author$project$DnD$pageX, $author$project$DnD$pageY))))
						]));
			} else {
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$elm$browser$Browser$Events$onMouseMove(
							A2(
								$elm$json$Json$Decode$map,
								wrap,
								A2(
									$elm$json$Json$Decode$map,
									$author$project$DnD$Dragging,
									A3($elm$json$Json$Decode$map2, $author$project$DnD$MousePosition, $author$project$DnD$pageX, $author$project$DnD$pageY)))),
							$elm$browser$Browser$Events$onMouseUp(
							A2(
								$elm$json$Json$Decode$map,
								wrap,
								A2(
									$elm$json$Json$Decode$map,
									$author$project$DnD$DragEnd,
									A3($elm$json$Json$Decode$map2, $author$project$DnD$MousePosition, $author$project$DnD$pageX, $author$project$DnD$pageY))))
						]));
			}
		}
	});
var $author$project$DnD$init = F2(
	function (wrap, onDrop) {
		return {
			ft: $author$project$DnD$draggable(wrap),
			fv: $author$project$DnD$droppable(wrap),
			f5: $elm$core$Maybe$Nothing,
			gT: A2($author$project$DnD$subscriptions, wrap, onDrop)
		};
	});
var $author$project$Plans$floorPlanDnD = A2(
	$author$project$DnD$init,
	$author$project$Plans$FlorPlanDnDMsg,
	$author$project$DnD$ignoreDropPosition($author$project$Plans$FloorPlanDropped));
var $author$project$Plans$FileNotPicked = {$: 0};
var $author$project$Plans$NFP = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plans$freshNewFloorPlan = $author$project$Plans$NFP(
	{
		c7: $elm$core$Maybe$Nothing,
		cr: false,
		T: $author$project$Plans$FileNotPicked,
		f9: $author$project$Enectiva$ValidatedValue$init('')
	});
var $author$project$SelectList$SelectList = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$SelectList$fromLists = $author$project$SelectList$SelectList;
var $author$project$Enectiva$I18n$Translations = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$newTranslations = $author$project$Enectiva$I18n$Translations;
var $author$project$Plans$ObjectDnDMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Plans$ObjectDropped = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Plans$objectDnD = A2($author$project$DnD$init, $author$project$Plans$ObjectDnDMsg, $author$project$Plans$ObjectDropped);
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Plans$init = function (_v0) {
	var floorPlans = _v0.f;
	var unplacedObjects = _v0.ai;
	var entityId = _v0.bu;
	var locale = _v0.eg;
	var translations = _v0.S;
	var csrfToken = _v0.as;
	var um = A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$list($author$project$Plans$objectDecoder),
			unplacedObjects));
	var fps = A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$list($author$project$Plans$floorPlanDecoder),
			floorPlans));
	var state = {
		f: function () {
			if (fps.b) {
				var head = fps.a;
				var tail = fps.b;
				return A3(
					$author$project$SelectList$fromLists,
					_List_Nil,
					head,
					_Utils_ap(
						tail,
						_List_fromArray(
							[$author$project$Plans$freshNewFloorPlan])));
			} else {
				return A3($author$project$SelectList$fromLists, _List_Nil, $author$project$Plans$freshNewFloorPlan, _List_Nil);
			}
		}(),
		cw: {au: 0, bn: 0},
		bc: $author$project$Plans$objectDnD.f5,
		ad: $author$project$Plans$Editable($author$project$Plans$floorPlanDnD.f5),
		cI: {hb: 0, hc: 0},
		aV: _List_Nil,
		ai: um
	};
	return _Utils_Tuple2(
		{
			as: csrfToken,
			bu: entityId,
			b4: state,
			S: A2($author$project$Enectiva$I18n$newTranslations, locale, translations)
		},
		$author$project$Plans$cmdsWhenPlanOpened);
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Enectiva$Util$noCmd = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Plans$PlanResizeObserved = function (a) {
	return {$: 10, a: a};
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Ports$resized = _Platform_incomingPort(
	'resized',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					A2(
						$elm$json$Json$Decode$andThen,
						function (window) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (element) {
									return $elm$json$Json$Decode$succeed(
										{hN: element, ha: window});
								},
								A2(
									$elm$json$Json$Decode$field,
									'element',
									A2(
										$elm$json$Json$Decode$andThen,
										function (width) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (height) {
													return $elm$json$Json$Decode$succeed(
														{au: height, bn: width});
												},
												A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
										},
										A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int))));
						},
						A2(
							$elm$json$Json$Decode$field,
							'window',
							A2(
								$elm$json$Json$Decode$andThen,
								function (width) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (height) {
											return $elm$json$Json$Decode$succeed(
												{au: height, bn: width});
										},
										A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
								},
								A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int))))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Plans$planResizedSubscription = $author$project$Ports$resized(
	function (_v0) {
		var element = _v0.b.hN;
		return $author$project$Plans$PlanResizeObserved(element);
	});
var $author$project$Plans$subscriptions = function (_v0) {
	var state = _v0.b4;
	var cmds = function () {
		var _v1 = state.ad;
		if (!_v1.$) {
			var o = _v1.a;
			return _List_fromArray(
				[
					$author$project$Plans$floorPlanDnD.gT(o),
					$author$project$Plans$planResizedSubscription,
					$author$project$Plans$objectDnD.gT(state.bc)
				]);
		} else {
			return _List_fromArray(
				[
					$author$project$Plans$planResizedSubscription,
					$author$project$Plans$objectDnD.gT(state.bc)
				]);
		}
	}();
	return $elm$core$Platform$Sub$batch(cmds);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Plans$AcceptedFile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plans$AcceptedFileWithPreview = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Plans$DFP = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Plans$DeleteFloorPlanResponseReceived = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Plans$DraggedObject = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plans$DraggedPhysicalLocation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Plans$ElementFocused = {$: 24};
var $author$project$Plans$Failed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Plans$FailedToFocusElement = function (a) {
	return {$: 25, a: a};
};
var $author$project$Plans$FileTooBig = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Plans$ImagePreviewReceived = function (a) {
	return {$: 20, a: a};
};
var $author$project$Plans$ImageSelected = function (a) {
	return {$: 17, a: a};
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Plans$New = {$: 1};
var $author$project$Plans$Persisted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Plans$Saving = {$: 1};
var $author$project$Enectiva$Util$addCmd = F2(
	function (cmd, model) {
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Plans$cancelDeleteId = $author$project$Plans$planId + '_cancel_delete';
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$Plans$floorPlanIdToNumber = function (id) {
	if (!id.$) {
		var i = id.a;
		return $elm$core$Maybe$Just(i);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Plans$floorPlanToId = function (fp) {
	switch (fp.$) {
		case 0:
			var id = fp.a.fM;
			return $author$project$Plans$Persisted(id);
		case 1:
			var id = fp.b.fM;
			return $author$project$Plans$Persisted(id);
		default:
			return $author$project$Plans$New;
	}
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$View$focusId = F3(
	function (success, failure, htmlId) {
		return A2(
			$elm$core$Task$attempt,
			function (result) {
				if (!result.$) {
					return success;
				} else {
					var id = result.a;
					return failure(id);
				}
			},
			$elm$browser$Browser$Dom$focus(htmlId));
	});
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $author$project$Enectiva$ValidatedValue$isValid = function (str) {
	if (str.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Enectiva$I18n$locale = function (_v0) {
	var l = _v0.a;
	return l;
};
var $author$project$View$localizeUrl = F2(
	function (url, locale) {
		return '/' + (locale + url);
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$SelectList$map = F2(
	function (transform, _v0) {
		var beforeSel = _v0.a;
		var sel = _v0.b;
		var afterSel = _v0.c;
		return A3(
			$author$project$SelectList$SelectList,
			A2($elm$core$List$map, transform, beforeSel),
			transform(sel),
			A2($elm$core$List$map, transform, afterSel));
	});
var $author$project$Plans$maxAcceptedFileSizeInMegabytes = 5;
var $author$project$Plans$maxAcceptedFileSizeInBytes = (1024 * 1024) * $author$project$Plans$maxAcceptedFileSizeInMegabytes;
var $elm$file$File$name = _File_name;
var $author$project$Plans$nameInputId = $author$project$Plans$planId + '_name';
var $author$project$Plans$UpdateFloorPlanResponseReceived = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Plans$NameUpdate = function (name) {
	return {f9: name};
};
var $author$project$Plans$nameUpdateDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Plans$NameUpdate));
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.iP));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {gy: reqs, gS: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.g_;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.gy));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.gS)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					hi: r.hi,
					fh: r.fh,
					fz: A2(_Http_mapExpect, func, r.fz),
					fH: r.fH,
					f2: r.f2,
					gX: r.gX,
					g_: r.g_,
					g3: r.g3
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{hi: false, fh: r.fh, fz: r.fz, fH: r.fH, f2: r.f2, gX: r.gX, g_: r.g_, g3: r.g3}));
};
var $author$project$Enectiva$HttpExtra$request = F6(
	function (token, verb, decoder, url, body, tagger) {
		return $elm$http$Http$request(
			{
				fh: body,
				fz: A2($elm$http$Http$expectJson, tagger, decoder),
				fH: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-Token', token),
						A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
					]),
				f2: verb,
				gX: $elm$core$Maybe$Nothing,
				g_: $elm$core$Maybe$Nothing,
				g3: url
			});
	});
var $author$project$Enectiva$ValidatedValue$value = function (v) {
	switch (v.$) {
		case 1:
			var s = v.a;
			return s;
		case 2:
			var s = v.a;
			return s;
		default:
			var s = v.a;
			return s;
	}
};
var $author$project$Plans$nameUpdateRequest = F3(
	function (_v0, id, name) {
		var translations = _v0.S;
		var csrfToken = _v0.as;
		var url = A2(
			$author$project$View$localizeUrl,
			'/plans/' + $elm$core$String$fromInt(id),
			$author$project$Enectiva$I18n$locale(translations));
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(
							$author$project$Enectiva$ValidatedValue$value(name)))
					])));
		return A6(
			$author$project$Enectiva$HttpExtra$request,
			csrfToken,
			'PATCH',
			$author$project$Plans$nameUpdateDecoder,
			url,
			body,
			A2(
				$elm$core$Basics$composeR,
				$krisajenkins$remotedata$RemoteData$fromResult,
				$author$project$Plans$UpdateFloorPlanResponseReceived(id)));
	});
var $author$project$Enectiva$ValidatedValue$Invalid = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Enectiva$ValidatedValue$Valid = function (a) {
	return {$: 1, a: a};
};
var $elm$core$String$trim = _String_trim;
var $author$project$Enectiva$ValidatedValue$validateInner = F2(
	function (str, validator) {
		switch (str.$) {
			case 2:
				return str;
			case 1:
				var s = str.a;
				return validator(s);
			default:
				var s = str.a;
				return validator(s);
		}
	});
var $author$project$Enectiva$ValidatedValue$requireString = F2(
	function (msg, str) {
		return A2(
			$author$project$Enectiva$ValidatedValue$validateInner,
			str,
			function (s) {
				return ($elm$core$String$trim(s) === '') ? A2($author$project$Enectiva$ValidatedValue$Invalid, s, msg) : $author$project$Enectiva$ValidatedValue$Valid(s);
			});
	});
var $author$project$Enectiva$I18n$keyToKeyPath = $elm$core$String$split('.');
var $author$project$Enectiva$I18n$tHelp = F2(
	function (_v0, keyPath) {
		var translations = _v0.b;
		return A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$at, keyPath, $elm$json$Json$Decode$string),
			translations);
	});
var $author$project$Enectiva$I18n$t = F2(
	function (translations, key) {
		return A2(
			$elm$core$Result$withDefault,
			key,
			A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				$author$project$Enectiva$I18n$keyToKeyPath(key)));
	});
var $author$project$Plans$nameValidator = F2(
	function (translations, input) {
		return A2(
			$author$project$Enectiva$ValidatedValue$requireString,
			A2($author$project$Enectiva$I18n$t, translations, 'errors.messages.blank'),
			$author$project$Enectiva$ValidatedValue$init(input));
	});
var $author$project$SelectList$selected = function (_v0) {
	var sel = _v0.b;
	return sel;
};
var $author$project$Plans$unscaleCoordinates = F3(
	function (renderedImage, image, _v0) {
		var x = _v0.hb;
		var y = _v0.hc;
		return {
			hb: $elm$core$Basics$round((x * image.bn) / renderedImage.bn),
			hc: $elm$core$Basics$round((y * image.au) / renderedImage.au)
		};
	});
var $author$project$Plans$newPhysicalLocation = F3(
	function (state, object, cursorPosition) {
		var _v0 = $author$project$SelectList$selected(state.f);
		if (!_v0.$) {
			var fp = _v0.a;
			var positionOnPlan = {hb: cursorPosition.hb - state.cI.hb, hc: (cursorPosition.hc - state.cI.hc) - 5};
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					_Utils_Tuple2(
						A3($author$project$Plans$unscaleCoordinates, state.cw, fp.T, positionOnPlan),
						object),
					fp.fM));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Plans$ObjectPlacedResponseReceived = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Plans$placeObjectRequest = F4(
	function (_v0, id, _v1, draggedObject) {
		var translations = _v0.S;
		var csrfToken = _v0.as;
		var position = _v1.a;
		var object = _v1.b;
		var _v2 = function () {
			if (!object.$) {
				var meterId = object.a;
				return _Utils_Tuple2(
					'/place_meter',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'meter_id',
							$elm$json$Json$Encode$int(meterId))
						]));
			} else {
				var dsId = object.a;
				return _Utils_Tuple2(
					'/place_data_series',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'data_series_id',
							$elm$json$Json$Encode$int(dsId))
						]));
			}
		}();
		var urlSegment = _v2.a;
		var data = _v2.b;
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'position',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'x',
									$elm$json$Json$Encode$int(position.hb)),
									_Utils_Tuple2(
									'y',
									$elm$json$Json$Encode$int(position.hc))
								]))),
					data)));
		return A6(
			$author$project$Enectiva$HttpExtra$request,
			csrfToken,
			'POST',
			$author$project$Plans$physicalLocationDecoder,
			A2(
				$author$project$View$localizeUrl,
				'/plans/' + ($elm$core$String$fromInt(id) + urlSegment),
				$author$project$Enectiva$I18n$locale(translations)),
			body,
			A2($author$project$Plans$ObjectPlacedResponseReceived, id, draggedObject));
	});
var $author$project$Ports$querySize = _Platform_outgoingPort('querySize', $elm$json$Json$Encode$string);
var $elm_community$list_extra$List$Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3($elm$core$List$foldl, $elm$core$List$cons, list2, list1);
	});
var $elm_community$list_extra$List$Extra$removeHelp = F4(
	function (list, x, xs, previousElements) {
		removeHelp:
		while (true) {
			if (!xs.b) {
				return list;
			} else {
				var y = xs.a;
				var ys = xs.b;
				if (_Utils_eq(x, y)) {
					return A2($elm_community$list_extra$List$Extra$reverseAppend, previousElements, ys);
				} else {
					var $temp$list = list,
						$temp$x = x,
						$temp$xs = ys,
						$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
					list = $temp$list;
					x = $temp$x;
					xs = $temp$xs;
					previousElements = $temp$previousElements;
					continue removeHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		return A4($elm_community$list_extra$List$Extra$removeHelp, xs, x, xs, _List_Nil);
	});
var $author$project$Enectiva$Util$removeFromListBy = F2(
	function (predicate, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var y = xs.a;
			var ys = xs.b;
			return predicate(y) ? ys : A2(
				$elm$core$List$cons,
				y,
				A2($author$project$Enectiva$Util$removeFromListBy, predicate, ys));
		}
	});
var $author$project$Plans$ObjectRemovalResponseReceived = F3(
	function (a, b, c) {
		return {$: 15, a: a, b: b, c: c};
	});
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Enectiva$HttpExtra$requestWithoutResponse = F5(
	function (token, verb, url, body, tagger) {
		return $elm$http$Http$request(
			{
				fh: body,
				fz: $elm$http$Http$expectWhatever(tagger),
				fH: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-Token', token),
						A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
					]),
				f2: verb,
				gX: $elm$core$Maybe$Nothing,
				g_: $elm$core$Maybe$Nothing,
				g3: url
			});
	});
var $author$project$Plans$removeObjectRequest = F3(
	function (_v0, id, physicalLocation) {
		var translations = _v0.S;
		var csrfToken = _v0.as;
		var _v1 = function () {
			if (!physicalLocation.b.$) {
				var _v3 = physicalLocation.b;
				var meterId = _v3.a;
				return _Utils_Tuple2(
					'/remove_meter',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'meter_id',
							$elm$json$Json$Encode$int(meterId))
						]));
			} else {
				var _v4 = physicalLocation.b;
				var dsId = _v4.a;
				return _Utils_Tuple2(
					'/remove_data_series',
					_List_fromArray(
						[
							_Utils_Tuple2(
							'data_series_id',
							$elm$json$Json$Encode$int(dsId))
						]));
			}
		}();
		var urlSegment = _v1.a;
		var data = _v1.b;
		return A5(
			$author$project$Enectiva$HttpExtra$requestWithoutResponse,
			csrfToken,
			'DELETE',
			A2(
				$author$project$View$localizeUrl,
				'/plans/' + ($elm$core$String$fromInt(id) + urlSegment),
				$author$project$Enectiva$I18n$locale(translations)),
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(data)),
			A2($author$project$Plans$ObjectRemovalResponseReceived, id, physicalLocation));
	});
var $author$project$Plans$reorder = F2(
	function (followerId, movedItem) {
		return A2(
			$elm$core$List$foldr,
			F2(
				function (fp, acc) {
					return _Utils_eq(
						$author$project$Plans$floorPlanToId(fp),
						$author$project$Plans$Persisted(movedItem.fM)) ? acc : (_Utils_eq(
						$author$project$Plans$floorPlanToId(fp),
						followerId) ? A2(
						$elm$core$List$cons,
						$author$project$Plans$PFP(movedItem),
						A2($elm$core$List$cons, fp, acc)) : A2($elm$core$List$cons, fp, acc));
				}),
			_List_Nil);
	});
var $author$project$Plans$OrderSaveResponseReceived = function (a) {
	return {$: 9, a: a};
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Plans$saveOrderRequest = F2(
	function (_v0, floorPlans) {
		var translations = _v0.S;
		var entityId = _v0.bu;
		var csrfToken = _v0.as;
		var url = A2(
			$author$project$View$localizeUrl,
			'/entities/' + ($elm$core$String$fromInt(entityId) + '/plans/order'),
			$author$project$Enectiva$I18n$locale(translations));
		var body = $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'order',
						A2(
							$elm$json$Json$Encode$list,
							$elm$json$Json$Encode$int,
							A2(
								$elm$core$List$filterMap,
								$author$project$Plans$floorPlanIdToNumber,
								A2($elm$core$List$map, $author$project$Plans$floorPlanToId, floorPlans))))
					])));
		return A6(
			$author$project$Enectiva$HttpExtra$request,
			csrfToken,
			'PATCH',
			$elm$json$Json$Decode$list($author$project$Plans$floorPlanDecoder),
			url,
			body,
			$author$project$Plans$OrderSaveResponseReceived);
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$SelectList$selectHelp = F4(
	function (isSelectable, beforeList, selectedElem, afterList) {
		var _v0 = _Utils_Tuple2(beforeList, afterList);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v1 = _v0.b;
				var first = _v1.a;
				var rest = _v1.b;
				if (isSelectable(selectedElem)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(beforeList, selectedElem, afterList));
				} else {
					if (isSelectable(first)) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								_Utils_ap(
									beforeList,
									_List_fromArray(
										[selectedElem])),
								first,
								rest));
					} else {
						var _v2 = A4($author$project$SelectList$selectHelp, isSelectable, _List_Nil, first, rest);
						if (_v2.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var _v3 = _v2.a;
							var newBefore = _v3.a;
							var newSelected = _v3.b;
							var newAfter = _v3.c;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($elm$core$List$cons, selectedElem, newBefore),
									newSelected,
									newAfter));
						}
					}
				}
			}
		} else {
			var _v4 = _v0.a;
			var first = _v4.a;
			var rest = _v4.b;
			if (isSelectable(first)) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						_List_Nil,
						first,
						_Utils_ap(
							rest,
							A2($elm$core$List$cons, selectedElem, afterList))));
			} else {
				var _v5 = A4($author$project$SelectList$selectHelp, isSelectable, rest, selectedElem, afterList);
				if (_v5.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v6 = _v5.a;
					var newBefore = _v6.a;
					var newSelected = _v6.b;
					var newAfter = _v6.c;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							A2($elm$core$List$cons, first, newBefore),
							newSelected,
							newAfter));
				}
			}
		}
	});
var $author$project$SelectList$select = F2(
	function (isSelectable, original) {
		var beforeSel = original.a;
		var sel = original.b;
		var afterSel = original.c;
		var _v0 = A4($author$project$SelectList$selectHelp, isSelectable, beforeSel, sel, afterSel);
		if (_v0.$ === 1) {
			return original;
		} else {
			var _v1 = _v0.a;
			var newBefore = _v1.a;
			var newSel = _v1.b;
			var newAfter = _v1.c;
			return A3($author$project$SelectList$SelectList, newBefore, newSel, newAfter);
		}
	});
var $author$project$Plans$selectedId = function (floorPlans) {
	var _v0 = $author$project$SelectList$selected(floorPlans);
	switch (_v0.$) {
		case 0:
			var id = _v0.a.fM;
			return $author$project$Plans$Persisted(id);
		case 1:
			var id = _v0.b.fM;
			return $author$project$Plans$Persisted(id);
		default:
			return $author$project$Plans$New;
	}
};
var $author$project$Plans$setState = F2(
	function (model, state) {
		return _Utils_update(
			model,
			{b4: state});
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$file$File$size = _File_size;
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Plans$splitPersistedFloorPlansAtId = F2(
	function (id, list) {
		var predicate = function (fp) {
			switch (fp.$) {
				case 0:
					var p = fp.a;
					return _Utils_eq(
						$author$project$Plans$Persisted(p.fM),
						id);
				case 1:
					var p = fp.b;
					return _Utils_eq(
						$author$project$Plans$Persisted(p.fM),
						id);
				default:
					return _Utils_eq($author$project$Plans$New, id);
			}
		};
		return function (triple) {
			if ((!triple.$) && (!triple.a.b.$)) {
				var _v1 = triple.a;
				var before = _v1.a;
				var at = _v1.b.a;
				var after = _v1.c;
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(before, at, after));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(
			A2(
				$elm$core$Maybe$map,
				function (i) {
					return _Utils_Tuple3(
						A2($elm$core$List$take, i, list),
						A2($elm_community$list_extra$List$Extra$getAt, i, list),
						A2($elm$core$List$drop, i + 1, list));
				},
				A2($elm_community$list_extra$List$Extra$findIndex, predicate, list)));
	});
var $TSFoster$elm_tuple_extra$Tuple3$third = function (_v0) {
	var c = _v0.c;
	return c;
};
var $author$project$SelectList$toList = function (_v0) {
	var beforeSel = _v0.a;
	var sel = _v0.b;
	var afterSel = _v0.c;
	return _Utils_ap(
		beforeSel,
		A2($elm$core$List$cons, sel, afterSel));
};
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$DnD$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var dragMeta = msg.a;
				var xy = msg.b;
				return $elm$core$Maybe$Just(
					{c8: dragMeta, co: $elm$core$Maybe$Nothing, eJ: xy});
			case 1:
				var xy = msg.a;
				return A2(
					$elm$core$Maybe$map,
					function (d) {
						return _Utils_update(
							d,
							{eJ: xy});
					},
					model);
			case 2:
				var xy = msg.a;
				return $elm$core$Maybe$Nothing;
			case 3:
				var dropMeta = msg.a;
				return A2(
					$elm$core$Maybe$map,
					function (d) {
						return _Utils_update(
							d,
							{
								co: $elm$core$Maybe$Just(dropMeta)
							});
					},
					model);
			default:
				return A2(
					$elm$core$Maybe$map,
					function (d) {
						return _Utils_update(
							d,
							{co: $elm$core$Maybe$Nothing});
					},
					model);
		}
	});
var $author$project$Plans$updateFloorPlan = F4(
	function (idToMatch, transformPersisted, transformNew, record) {
		return _Utils_update(
			record,
			{
				f: A2(
					$author$project$SelectList$map,
					function (fp) {
						var _v0 = _Utils_Tuple2(fp, idToMatch);
						_v0$3:
						while (true) {
							if (!_v0.b.$) {
								switch (_v0.a.$) {
									case 0:
										var p = _v0.a.a;
										var id = _v0.b.a;
										return _Utils_eq(id, p.fM) ? $author$project$Plans$PFP(
											transformPersisted(p)) : fp;
									case 1:
										var _v1 = _v0.a;
										var dr = _v1.a;
										var p = _v1.b;
										var id = _v0.b.a;
										return _Utils_eq(id, p.fM) ? A2(
											$author$project$Plans$DFP,
											dr,
											transformPersisted(p)) : fp;
									default:
										break _v0$3;
								}
							} else {
								if (_v0.a.$ === 2) {
									var p = _v0.a.a;
									var _v2 = _v0.b;
									return $author$project$Plans$NFP(
										transformNew(p));
								} else {
									break _v0$3;
								}
							}
						}
						return fp;
					},
					record.f)
			});
	});
var $author$project$Plans$updateFloorPlanWithCmd = F4(
	function (idToMatch, transformPersisted, transformNew, record) {
		var transformedWithCmds = A2(
			$author$project$SelectList$map,
			function (fp) {
				var _v0 = _Utils_Tuple2(fp, idToMatch);
				_v0$3:
				while (true) {
					if (!_v0.b.$) {
						switch (_v0.a.$) {
							case 0:
								var p = _v0.a.a;
								var id = _v0.b.a;
								return _Utils_eq(id, p.fM) ? A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Plans$PFP,
									transformPersisted(p)) : $author$project$Enectiva$Util$noCmd(fp);
							case 1:
								var _v1 = _v0.a;
								var dr = _v1.a;
								var p = _v1.b;
								var id = _v0.b.a;
								return _Utils_eq(id, p.fM) ? A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Plans$DFP(dr),
									transformPersisted(p)) : $author$project$Enectiva$Util$noCmd(fp);
							default:
								break _v0$3;
						}
					} else {
						if (_v0.a.$ === 2) {
							var p = _v0.a.a;
							var _v2 = _v0.b;
							return A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Plans$NFP,
								transformNew(p));
						} else {
							break _v0$3;
						}
					}
				}
				return $author$project$Enectiva$Util$noCmd(fp);
			},
			record.f);
		return _Utils_Tuple2(
			_Utils_update(
				record,
				{
					f: A2($author$project$SelectList$map, $elm$core$Tuple$first, transformedWithCmds)
				}),
			$elm$core$Platform$Cmd$batch(
				$author$project$SelectList$toList(
					A2($author$project$SelectList$map, $elm$core$Tuple$second, transformedWithCmds))));
	});
var $author$project$Plans$updatePersistedFloorPlanFieldsHelp = F2(
	function (inMemory, server) {
		return _Utils_update(
			inMemory,
			{T: server.T, f9: server.f9, K: server.K});
	});
var $author$project$Plans$updatePersistedFloorPlanFields = F2(
	function (inMemory, server) {
		var _v0 = _Utils_Tuple2(inMemory, server);
		_v0$2:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 0:
						var a = _v0.a.a;
						var b = _v0.b.a;
						return $author$project$Plans$PFP(
							A2($author$project$Plans$updatePersistedFloorPlanFieldsHelp, a, b));
					case 1:
						var _v1 = _v0.a;
						var dr = _v1.a;
						var a = _v1.b;
						var b = _v0.b.a;
						return A2(
							$author$project$Plans$DFP,
							dr,
							A2($author$project$Plans$updatePersistedFloorPlanFieldsHelp, a, b));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return inMemory;
	});
var $author$project$Plans$PlanImageUploadResponseReceived = function (a) {
	return {$: 21, a: a};
};
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Plans$uploadImage = F4(
	function (model, file, name, _v0) {
		var width = _v0.bn;
		var height = _v0.au;
		return $elm$http$Http$request(
			{
				fh: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'plan[image]', file),
							A2(
							$elm$http$Http$stringPart,
							'plan[name]',
							$author$project$Enectiva$ValidatedValue$value(name)),
							A2(
							$elm$http$Http$stringPart,
							'plan[entity_id]',
							$elm$core$String$fromInt(model.bu)),
							A2(
							$elm$http$Http$stringPart,
							'plan[dimensions][width]',
							$elm$core$String$fromInt(width)),
							A2(
							$elm$http$Http$stringPart,
							'plan[dimensions][height]',
							$elm$core$String$fromInt(height))
						])),
				fz: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Plans$PlanImageUploadResponseReceived),
					$author$project$Plans$floorPlanDecoder),
				fH: _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CSRF-Token', model.as),
						A2($elm$http$Http$header, 'X-Requested-With', 'XMLHttpRequest')
					]),
				f2: 'POST',
				gX: $elm$core$Maybe$Nothing,
				g_: $elm$core$Maybe$Nothing,
				g3: A2(
					$author$project$View$localizeUrl,
					'/plans',
					$author$project$Enectiva$I18n$locale(model.S))
			});
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Plans$withoutNew = $elm$core$List$filterMap(
	function (fp) {
		if (fp.$ === 2) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Just(fp);
		}
	});
var $author$project$Plans$update = F2(
	function (msg, model) {
		var state = model.b4;
		_v0$33:
		while (true) {
			switch (msg.$) {
				case 0:
					var id = msg.a;
					return $author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Plans$setState,
							model,
							_Utils_update(
								state,
								{
									f: A2(
										$author$project$SelectList$select,
										function (fp) {
											switch (fp.$) {
												case 0:
													var p = fp.a;
													return _Utils_eq(
														$author$project$Plans$Persisted(p.fM),
														id);
												case 1:
													var p = fp.b;
													return _Utils_eq(
														$author$project$Plans$Persisted(p.fM),
														id);
												default:
													return _Utils_eq(id, $author$project$Plans$New);
											}
										},
										state.f)
								})));
				case 1:
					var id = msg.a;
					var input = msg.b;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Plans$setState(model),
						A4(
							$author$project$Plans$updateFloorPlanWithCmd,
							id,
							function (fp) {
								var name = A2($author$project$Plans$nameValidator, model.S, input);
								var _v2 = $author$project$Enectiva$ValidatedValue$isValid(name) ? _Utils_Tuple2(
									A3($author$project$Plans$nameUpdateRequest, model, fp.fM, name),
									$elm$core$Maybe$Just($krisajenkins$remotedata$RemoteData$Loading)) : _Utils_Tuple2($elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
								var nameUpdateCmd = _v2.a;
								var request = _v2.b;
								return A2(
									$author$project$Enectiva$Util$addCmd,
									nameUpdateCmd,
									_Utils_update(
										fp,
										{
											f9: name,
											cY: A2($elm$core$Maybe$withDefault, fp.cY, request)
										}));
							},
							function (fp) {
								return $author$project$Enectiva$Util$noCmd(
									_Utils_update(
										fp,
										{
											f9: A2($author$project$Plans$nameValidator, model.S, input)
										}));
							},
							state));
				case 3:
					if (!msg.a.$) {
						var id = msg.a.a;
						return A2(
							$author$project$Enectiva$Util$addCmd,
							A3($author$project$View$focusId, $author$project$Plans$ElementFocused, $author$project$Plans$FailedToFocusElement, $author$project$Plans$cancelDeleteId),
							A2(
								$author$project$Plans$setState,
								model,
								_Utils_update(
									state,
									{
										f: A2(
											$author$project$SelectList$map,
											function (fp) {
												if (!fp.$) {
													var p = fp.a;
													return _Utils_eq(id, p.fM) ? A2($author$project$Plans$DFP, $krisajenkins$remotedata$RemoteData$NotAsked, p) : fp;
												} else {
													return fp;
												}
											},
											state.f)
									})));
					} else {
						break _v0$33;
					}
				case 4:
					if (!msg.a.$) {
						var id = msg.a.a;
						return $author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Plans$setState,
								model,
								_Utils_update(
									state,
									{
										f: A2(
											$author$project$SelectList$map,
											function (fp) {
												if (fp.$ === 1) {
													var p = fp.b;
													return _Utils_eq(id, p.fM) ? $author$project$Plans$PFP(p) : fp;
												} else {
													return fp;
												}
											},
											state.f)
									})));
					} else {
						break _v0$33;
					}
				case 5:
					if (!msg.a.$) {
						var id = msg.a.a;
						var url = A2(
							$author$project$View$localizeUrl,
							'/plans/' + $elm$core$String$fromInt(id),
							$author$project$Enectiva$I18n$locale(model.S));
						var cmd = A6(
							$author$project$Enectiva$HttpExtra$request,
							model.as,
							'DELETE',
							A2(
								$elm$json$Json$Decode$field,
								'unplacedObjects',
								$elm$json$Json$Decode$list($author$project$Plans$objectDecoder)),
							url,
							$elm$http$Http$emptyBody,
							A2(
								$elm$core$Basics$composeR,
								$krisajenkins$remotedata$RemoteData$fromResult,
								$author$project$Plans$DeleteFloorPlanResponseReceived(
									$author$project$Plans$Persisted(id))));
						return A2(
							$author$project$Enectiva$Util$addCmd,
							cmd,
							A2(
								$author$project$Plans$setState,
								model,
								_Utils_update(
									state,
									{
										f: A2(
											$author$project$SelectList$map,
											function (fp) {
												if (fp.$ === 1) {
													var p = fp.b;
													return _Utils_eq(id, p.fM) ? A2($author$project$Plans$DFP, $krisajenkins$remotedata$RemoteData$Loading, p) : fp;
												} else {
													return fp;
												}
											},
											state.f)
									})));
					} else {
						break _v0$33;
					}
				case 6:
					if (!msg.a.$) {
						if (msg.b.$ === 3) {
							var id = msg.a.a;
							var unplacedObjects = msg.b.a;
							var splitAtId = A2(
								$author$project$Plans$splitPersistedFloorPlansAtId,
								$author$project$Plans$Persisted(id),
								$author$project$SelectList$toList(state.f));
							var floorPlans = function () {
								if (!splitAtId.$) {
									if (splitAtId.a.c.b) {
										var _v7 = splitAtId.a;
										var before = _v7.a;
										var _v8 = _v7.c;
										var newSelected = _v8.a;
										var after = _v8.b;
										return A3($author$project$SelectList$fromLists, before, newSelected, after);
									} else {
										if (!splitAtId.a.a.b) {
											var _v9 = splitAtId.a;
											return state.f;
										} else {
											var _v10 = splitAtId.a;
											var before = _v10.a;
											var _v11 = $elm$core$List$reverse(before);
											if (_v11.b) {
												var newSelected = _v11.a;
												var b = _v11.b;
												return A3(
													$author$project$SelectList$fromLists,
													$elm$core$List$reverse(b),
													newSelected,
													_List_Nil);
											} else {
												return A3($author$project$SelectList$fromLists, _List_Nil, $author$project$Plans$freshNewFloorPlan, _List_Nil);
											}
										}
									}
								} else {
									return state.f;
								}
							}();
							return A2(
								$author$project$Enectiva$Util$addCmd,
								$author$project$Plans$getPlanPageCoordinates,
								A2(
									$author$project$Plans$setState,
									model,
									_Utils_update(
										state,
										{f: floorPlans, ai: unplacedObjects})));
						} else {
							var id = msg.a.a;
							var newRequest = msg.b;
							return $author$project$Enectiva$Util$noCmd(
								A2(
									$author$project$Plans$setState,
									model,
									_Utils_update(
										state,
										{
											f: A2(
												$author$project$SelectList$map,
												function (fp) {
													if (fp.$ === 1) {
														var p = fp.b;
														return _Utils_eq(id, p.fM) ? A2($author$project$Plans$DFP, newRequest, p) : fp;
													} else {
														return fp;
													}
												},
												state.f)
										})));
						}
					} else {
						break _v0$33;
					}
				case 8:
					var dndMsg = msg.a;
					return $author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Plans$setState,
							model,
							_Utils_update(
								state,
								{
									ad: function () {
										var _v13 = state.ad;
										if (!_v13.$) {
											var order = _v13.a;
											return $author$project$Plans$Editable(
												A2($author$project$DnD$update, dndMsg, order));
										} else {
											return state.ad;
										}
									}()
								})));
				case 7:
					var droppedTarget = msg.a;
					var movedFloorPlan = msg.b;
					var persistedFloorPlansInTheOriginalOrder = $author$project$SelectList$toList(state.f);
					var reorderedFloorPlans = A3($author$project$Plans$reorder, droppedTarget, movedFloorPlan, persistedFloorPlansInTheOriginalOrder);
					var saveRequest = A2($author$project$Plans$saveOrderRequest, model, reorderedFloorPlans);
					var floorPlansSplitAtTheSelected = A2(
						$author$project$Plans$splitPersistedFloorPlansAtId,
						$author$project$Plans$selectedId(state.f),
						reorderedFloorPlans);
					var floorPlans = function () {
						if (!floorPlansSplitAtTheSelected.$) {
							var _v15 = floorPlansSplitAtTheSelected.a;
							var before = _v15.a;
							var selected = _v15.b;
							var after = _v15.c;
							return A3($author$project$SelectList$fromLists, before, selected, after);
						} else {
							return state.f;
						}
					}();
					return A2(
						$author$project$Enectiva$Util$addCmd,
						saveRequest,
						A2(
							$author$project$Plans$setState,
							model,
							_Utils_update(
								state,
								{f: floorPlans, ad: $author$project$Plans$Saving})));
				case 9:
					if (msg.a.$ === 1) {
						var err = msg.a.a;
						return $author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Plans$setState,
								model,
								_Utils_update(
									state,
									{
										ad: $author$project$Plans$Failed(err)
									})));
					} else {
						var floorPlans = msg.a.a;
						var orderingTemplate = $elm$core$Dict$fromList(
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (idx, _v23) {
										var id = _v23.a;
										var fp = _v23.b;
										return _Utils_Tuple2(
											id,
											_Utils_Tuple2(idx, fp));
									}),
								A2(
									$elm$core$List$filterMap,
									function (fp) {
										return A2(
											$elm$core$Maybe$map,
											function (id) {
												return _Utils_Tuple2(id, fp);
											},
											$author$project$Plans$floorPlanIdToNumber(
												$author$project$Plans$floorPlanToId(fp)));
									},
									floorPlans)));
						var sortedAndUpdatedFloorPlans = A2(
							$elm$core$List$map,
							function (_v22) {
								var fp = _v22.a;
								var serverFp = _v22.b;
								return A2($author$project$Plans$updatePersistedFloorPlanFields, fp, serverFp);
							},
							A2(
								$elm$core$List$sortBy,
								$TSFoster$elm_tuple_extra$Tuple3$third,
								A2(
									$elm$core$List$filterMap,
									function (fp) {
										var _v19 = $author$project$Plans$floorPlanIdToNumber(
											$author$project$Plans$floorPlanToId(fp));
										if (_v19.$ === 1) {
											return $elm$core$Maybe$Just(
												_Utils_Tuple3(
													fp,
													fp,
													$elm$core$Dict$size(orderingTemplate) + 1));
										} else {
											var id = _v19.a;
											var _v20 = A2($elm$core$Dict$get, id, orderingTemplate);
											if (!_v20.$) {
												var _v21 = _v20.a;
												var sortIndex = _v21.a;
												var serverFp = _v21.b;
												return $elm$core$Maybe$Just(
													_Utils_Tuple3(fp, serverFp, sortIndex));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}
									},
									$author$project$SelectList$toList(state.f))));
						var splitAtSelectedId = A2(
							$author$project$Plans$splitPersistedFloorPlansAtId,
							$author$project$Plans$selectedId(state.f),
							sortedAndUpdatedFloorPlans);
						var updatedFloorPlans = function () {
							if (!splitAtSelectedId.$) {
								var _v17 = splitAtSelectedId.a;
								var before = _v17.a;
								var selected = _v17.b;
								var after = _v17.c;
								return A3($author$project$SelectList$fromLists, before, selected, after);
							} else {
								if (sortedAndUpdatedFloorPlans.b) {
									var head = sortedAndUpdatedFloorPlans.a;
									var tail = sortedAndUpdatedFloorPlans.b;
									return A3($author$project$SelectList$fromLists, _List_Nil, head, tail);
								} else {
									return A3($author$project$SelectList$fromLists, _List_Nil, $author$project$Plans$freshNewFloorPlan, _List_Nil);
								}
							}
						}();
						return $author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Plans$setState,
								model,
								_Utils_update(
									state,
									{
										f: updatedFloorPlans,
										ad: $author$project$Plans$Editable($author$project$Plans$floorPlanDnD.f5)
									})));
					}
				case 11:
					var dndMsg = msg.a;
					return $author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Plans$setState,
							model,
							_Utils_update(
								state,
								{
									bc: A2($author$project$DnD$update, dndMsg, state.bc)
								})));
				case 12:
					if (!msg.a.$) {
						if (!msg.b.$) {
							var _v24 = msg.a;
							var object = msg.b.a;
							var cursorPosition = msg.c;
							var _v25 = A3($author$project$Plans$newPhysicalLocation, state, object, cursorPosition);
							if (!_v25.$) {
								var _v26 = _v25.a;
								var physicalLocation = _v26.a;
								var floorPlanId = _v26.b;
								return A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Plans$setState(model),
									A4(
										$author$project$Plans$updateFloorPlanWithCmd,
										$author$project$Plans$Persisted(floorPlanId),
										function (fp) {
											return A2(
												$author$project$Enectiva$Util$addCmd,
												A4(
													$author$project$Plans$placeObjectRequest,
													model,
													fp.fM,
													physicalLocation,
													$author$project$Plans$DraggedObject(object)),
												_Utils_update(
													fp,
													{
														U: A2($elm$core$List$cons, physicalLocation, fp.U)
													}));
										},
										A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Enectiva$Util$noCmd),
										_Utils_update(
											state,
											{
												ai: A2($elm_community$list_extra$List$Extra$remove, object, state.ai)
											})));
							} else {
								return $author$project$Enectiva$Util$noCmd(model);
							}
						} else {
							var _v27 = msg.a;
							var oldPhysicalLocation = msg.b.a;
							var cursorPosition = msg.c;
							var _v28 = A3($author$project$Plans$newPhysicalLocation, state, oldPhysicalLocation.b, cursorPosition);
							if (!_v28.$) {
								var _v29 = _v28.a;
								var physicalLocation = _v29.a;
								var floorPlanId = _v29.b;
								return A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Plans$setState(model),
									A4(
										$author$project$Plans$updateFloorPlanWithCmd,
										$author$project$Plans$Persisted(floorPlanId),
										function (fp) {
											return A2(
												$author$project$Enectiva$Util$addCmd,
												A4(
													$author$project$Plans$placeObjectRequest,
													model,
													fp.fM,
													physicalLocation,
													$author$project$Plans$DraggedPhysicalLocation(oldPhysicalLocation)),
												_Utils_update(
													fp,
													{
														K: A2($elm_community$list_extra$List$Extra$remove, oldPhysicalLocation, fp.K),
														U: A2($elm$core$List$cons, physicalLocation, fp.U)
													}));
										},
										A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Enectiva$Util$noCmd),
										state));
							} else {
								return $author$project$Enectiva$Util$noCmd(model);
							}
						}
					} else {
						if (msg.b.$ === 1) {
							var id = msg.a.a;
							var physicalLocation = msg.b.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Plans$setState(model),
								A4(
									$author$project$Plans$updateFloorPlanWithCmd,
									$author$project$Plans$Persisted(id),
									function (fp) {
										return A2(
											$author$project$Enectiva$Util$addCmd,
											A3($author$project$Plans$removeObjectRequest, model, fp.fM, physicalLocation),
											_Utils_update(
												fp,
												{
													K: A2($elm_community$list_extra$List$Extra$remove, physicalLocation, fp.K)
												}));
									},
									A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Enectiva$Util$noCmd),
									_Utils_update(
										state,
										{
											aV: A2($elm$core$List$cons, physicalLocation.b, state.aV)
										})));
						} else {
							break _v0$33;
						}
					}
				case 16:
					return A2(
						$author$project$Enectiva$Util$addCmd,
						A2(
							$elm$file$File$Select$file,
							_List_fromArray(
								['image/*']),
							$author$project$Plans$ImageSelected),
						model);
				case 18:
					return $author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Plans$setState,
							model,
							A4(
								$author$project$Plans$updateFloorPlan,
								$author$project$Plans$New,
								$elm$core$Basics$identity,
								function (fp) {
									return _Utils_update(
										fp,
										{cr: true});
								},
								state)));
				case 19:
					return $author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Plans$setState,
							model,
							A4(
								$author$project$Plans$updateFloorPlan,
								$author$project$Plans$New,
								$elm$core$Basics$identity,
								function (fp) {
									return _Utils_update(
										fp,
										{cr: false});
								},
								state)));
				case 17:
					var file = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Plans$setState(model),
						A4(
							$author$project$Plans$updateFloorPlanWithCmd,
							$author$project$Plans$New,
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Enectiva$Util$noCmd),
							function (fp) {
								var _v30 = (_Utils_cmp(
									$elm$file$File$size(file),
									$author$project$Plans$maxAcceptedFileSizeInBytes) > 0) ? _Utils_Tuple3(
									A2(
										$author$project$Plans$FileTooBig,
										$elm$file$File$name(file),
										$elm$file$File$size(file)),
									fp.f9,
									$elm$core$Platform$Cmd$none) : _Utils_Tuple3(
									$author$project$Plans$AcceptedFile(file),
									($author$project$Enectiva$ValidatedValue$value(fp.f9) === '') ? A2(
										$author$project$Plans$nameValidator,
										model.S,
										$elm$file$File$name(file)) : fp.f9,
									A2(
										$elm$core$Task$perform,
										$author$project$Plans$ImagePreviewReceived,
										$elm$file$File$toUrl(file)));
								var image = _v30.a;
								var name = _v30.b;
								var cmd = _v30.c;
								return _Utils_Tuple2(
									_Utils_update(
										fp,
										{T: image, f9: name}),
									cmd);
							},
							state));
				case 20:
					var preview = msg.a;
					return $author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Plans$setState,
							model,
							A4(
								$author$project$Plans$updateFloorPlan,
								$author$project$Plans$New,
								$elm$core$Basics$identity,
								function (fp) {
									return _Utils_update(
										fp,
										{
											T: function () {
												var _v31 = fp.T;
												if (_v31.$ === 1) {
													var file = _v31.a;
													return A2($author$project$Plans$AcceptedFileWithPreview, file, preview);
												} else {
													return fp.T;
												}
											}()
										});
								},
								state)));
				case 22:
					var dimensions = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Plans$setState(model),
						A4(
							$author$project$Plans$updateFloorPlanWithCmd,
							$author$project$Plans$New,
							A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $author$project$Enectiva$Util$noCmd),
							function (fp) {
								var request = function () {
									var _v32 = fp.T;
									switch (_v32.$) {
										case 2:
											var file = _v32.a;
											return A4($author$project$Plans$uploadImage, model, file, fp.f9, dimensions);
										case 1:
											var file = _v32.a;
											return A4($author$project$Plans$uploadImage, model, file, fp.f9, dimensions);
										default:
											return $elm$core$Platform$Cmd$none;
									}
								}();
								return A2(
									$author$project$Enectiva$Util$addCmd,
									request,
									_Utils_update(
										fp,
										{
											c7: $elm$core$Maybe$Just(dimensions)
										}));
							},
							state));
				case 21:
					if (msg.a.$ === 3) {
						var floorPlan = msg.a.a;
						var floorPlans = $author$project$Plans$withoutNew(
							$author$project$SelectList$toList(state.f));
						var cmd = $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Plans$cmdsWhenPlanOpened,
									A3($author$project$View$focusId, $author$project$Plans$ElementFocused, $author$project$Plans$FailedToFocusElement, $author$project$Plans$nameInputId)
								]));
						return A2(
							$author$project$Enectiva$Util$addCmd,
							cmd,
							A2(
								$author$project$Plans$setState,
								model,
								_Utils_update(
									state,
									{
										f: A3(
											$author$project$SelectList$fromLists,
											floorPlans,
											floorPlan,
											_List_fromArray(
												[$author$project$Plans$freshNewFloorPlan]))
									})));
					} else {
						return $author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Plans$setState,
								model,
								A4(
									$author$project$Plans$updateFloorPlan,
									$author$project$Plans$New,
									$elm$core$Basics$identity,
									function (fp) {
										return _Utils_update(
											fp,
											{
												c7: $elm$core$Maybe$Nothing,
												T: $author$project$Plans$FileNotPicked,
												f9: $author$project$Enectiva$ValidatedValue$init('')
											});
									},
									state)));
					}
				case 2:
					var id = msg.a;
					var nameUpdate = msg.b;
					return $author$project$Enectiva$Util$noCmd(
						A2(
							$author$project$Plans$setState,
							model,
							A4(
								$author$project$Plans$updateFloorPlan,
								$author$project$Plans$Persisted(id),
								function (fp) {
									return _Utils_update(
										fp,
										{cY: nameUpdate});
								},
								$elm$core$Basics$identity,
								state)));
				case 10:
					var dimensions = msg.a;
					return A2(
						$author$project$Enectiva$Util$addCmd,
						$author$project$Plans$getPlanPageCoordinates,
						A2(
							$author$project$Plans$setState,
							model,
							_Utils_update(
								state,
								{cw: dimensions})));
				case 13:
					if (!msg.a.$) {
						var planPosition = msg.a.a;
						return $author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Plans$setState,
								model,
								_Utils_update(
									state,
									{cI: planPosition})));
					} else {
						break _v0$33;
					}
				case 23:
					return A2(
						$author$project$Enectiva$Util$addCmd,
						$author$project$Ports$querySize($author$project$Plans$planId),
						model);
				case 14:
					if (!msg.b.$) {
						if (msg.c.$ === 1) {
							var id = msg.a;
							var object = msg.b.a;
							return $author$project$Enectiva$Util$noCmd(
								A2(
									$author$project$Plans$setState,
									model,
									A4(
										$author$project$Plans$updateFloorPlan,
										$author$project$Plans$Persisted(id),
										function (fp) {
											return _Utils_update(
												fp,
												{
													U: A2(
														$author$project$Enectiva$Util$removeFromListBy,
														function (_v33) {
															var m = _v33.b;
															return _Utils_eq(m, object);
														},
														fp.U)
												});
										},
										$elm$core$Basics$identity,
										_Utils_update(
											state,
											{
												ai: A2($elm$core$List$cons, object, state.ai)
											}))));
						} else {
							var id = msg.a;
							var object = msg.b.a;
							var physicalLocation = msg.c.a;
							return $author$project$Enectiva$Util$noCmd(
								A2(
									$author$project$Plans$setState,
									model,
									A4(
										$author$project$Plans$updateFloorPlan,
										$author$project$Plans$Persisted(id),
										function (fp) {
											return _Utils_update(
												fp,
												{
													K: A2($elm$core$List$cons, physicalLocation, fp.K),
													U: A2(
														$author$project$Enectiva$Util$removeFromListBy,
														function (_v35) {
															var m = _v35.b;
															return _Utils_eq(m, object);
														},
														fp.U)
												});
										},
										$elm$core$Basics$identity,
										state)));
						}
					} else {
						if (msg.c.$ === 1) {
							var id = msg.a;
							var physicalLocation = msg.b.a;
							return $author$project$Enectiva$Util$noCmd(
								A2(
									$author$project$Plans$setState,
									model,
									A4(
										$author$project$Plans$updateFloorPlan,
										$author$project$Plans$Persisted(id),
										function (fp) {
											return _Utils_update(
												fp,
												{
													K: A2($elm$core$List$cons, physicalLocation, fp.K),
													U: A2(
														$author$project$Enectiva$Util$removeFromListBy,
														function (_v34) {
															var m = _v34.b;
															return _Utils_eq(m, physicalLocation.b);
														},
														fp.U)
												});
										},
										$elm$core$Basics$identity,
										state)));
						} else {
							var id = msg.a;
							var originalPhysicalLocation = msg.b.a;
							var physicalLocation = msg.c.a;
							return $author$project$Enectiva$Util$noCmd(
								A2(
									$author$project$Plans$setState,
									model,
									A4(
										$author$project$Plans$updateFloorPlan,
										$author$project$Plans$Persisted(id),
										function (fp) {
											return _Utils_update(
												fp,
												{
													K: A2($elm$core$List$cons, physicalLocation, fp.K),
													U: A2(
														$author$project$Enectiva$Util$removeFromListBy,
														function (_v36) {
															var m = _v36.b;
															return _Utils_eq(m, originalPhysicalLocation.b);
														},
														fp.U)
												});
										},
										$elm$core$Basics$identity,
										state)));
						}
					}
				case 15:
					if (msg.c.$ === 1) {
						var id = msg.a;
						var physicalLocation = msg.b;
						var meter = physicalLocation.b;
						return $author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Plans$setState,
								model,
								A4(
									$author$project$Plans$updateFloorPlan,
									$author$project$Plans$Persisted(id),
									function (fp) {
										return _Utils_update(
											fp,
											{
												K: A2($elm$core$List$cons, physicalLocation, fp.K)
											});
									},
									$elm$core$Basics$identity,
									_Utils_update(
										state,
										{
											aV: A2($elm_community$list_extra$List$Extra$remove, meter, state.aV)
										}))));
					} else {
						var physicalLocation = msg.b;
						var meter = physicalLocation.b;
						return $author$project$Enectiva$Util$noCmd(
							A2(
								$author$project$Plans$setState,
								model,
								_Utils_update(
									state,
									{
										aV: A2($elm_community$list_extra$List$Extra$remove, meter, state.aV),
										ai: A2($elm$core$List$cons, meter, state.ai)
									})));
					}
				default:
					break _v0$33;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$SelectionState$Selected = 0;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$Plans$counteractHardcodedValue = 15;
var $author$project$DnD$px = function (number) {
	return $elm$core$String$fromInt(number) + 'px';
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$DnD$draggedStyle = function (position) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
			A2(
			$elm$html$Html$Attributes$style,
			'left',
			$author$project$DnD$px(position.hb + 10)),
			A2(
			$elm$html$Html$Attributes$style,
			'top',
			$author$project$DnD$px(position.hc + 10))
		]);
};
var $author$project$Enectiva$View$nothing = $elm$html$Html$text('');
var $author$project$DnD$dragged = F2(
	function (_v0, view) {
		var model = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Enectiva$View$nothing,
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					var dragMeta = _v1.c8;
					var position = _v1.eJ;
					return A2(
						$elm$html$Html$div,
						$author$project$DnD$draggedStyle(position),
						_List_fromArray(
							[
								view(dragMeta)
							]));
				},
				model));
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Types$px = function (num) {
	return $elm$core$String$fromFloat(num) + 'px';
};
var $author$project$Plans$floorPlanBeingMoved = function (order) {
	if (!order.$) {
		var draggable = order.a;
		return A2(
			$author$project$DnD$dragged,
			draggable,
			function (fp) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white py-1 pr-2 pl-4 box-shadow min-w-32 rounded relative'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							'-' + $author$project$Types$px($author$project$Plans$counteractHardcodedValue))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Enectiva$ValidatedValue$value(fp.f9))
						]));
			});
	} else {
		return $author$project$Enectiva$View$nothing;
	}
};
var $author$project$Plans$FloorPlanButtonClicked = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$SelectionState$apply = F3(
	function (ifSelected, ifNotSelected, state) {
		if (!state) {
			return ifSelected(0);
		} else {
			return ifNotSelected(0);
		}
	});
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$SelectionState$isSelected = function (os) {
	if (!os) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Plans$navigationItemClass = function (selection) {
	return $elm$html$Html$Attributes$classList(
		_List_fromArray(
			[
				_Utils_Tuple2('py-1.5 px-2 relative border-box flex items-center overflow-hidden rounded', true),
				_Utils_Tuple2(
				'font-bold bg-grey-200',
				$author$project$SelectionState$isSelected(selection))
			]));
};
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Plans$floorPlanListItemViewHelp = F3(
	function (currentDropTarget, selection, floorPlan) {
		var id = floorPlan.fM;
		var name = floorPlan.f9;
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Plans$floorPlanDnD.fv,
					$author$project$Plans$Persisted(id),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-8 bg-grey-500'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'hidden',
											!_Utils_eq(
												currentDropTarget,
												$elm$core$Maybe$Just(
													$author$project$Plans$Persisted(id))))
										]))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Plans$navigationItemClass(selection)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Plans$floorPlanDnD.ft,
									floorPlan,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('inline-block font-bold text-grey-600 py-1 mr-1 cursor-move w-4 text-left grow-0 shrink-0')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('::')
										])),
									A3(
									$author$project$SelectionState$apply,
									$elm$core$Basics$always(
										$elm$html$Html$text(
											$author$project$Enectiva$ValidatedValue$value(name))),
									$elm$core$Basics$always(
										A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('button'),
													$elm$html$Html$Events$onClick(
													$author$project$Plans$FloorPlanButtonClicked(
														$author$project$Plans$Persisted(id))),
													$elm$html$Html$Attributes$class('text-left grow')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Enectiva$ValidatedValue$value(name))
												]))),
									selection)
								]))
						]))
				]));
	});
var $author$project$DnD$getDragMeta = function (_v0) {
	var d = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.c8;
		},
		d);
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$DnD$getDropMeta = function (_v0) {
	var d = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.co;
		},
		d);
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$SvgIcons$plus = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('-0.327 0.827 19.5 19.5'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M2.956,3.964c-3.652,3.57-3.717,9.429-0.146,13.08c3.571,3.653,9.429,3.72,13.081,0.146c0.051-0.047,0.1-0.097,0.146-0.146 c3.571-3.651,3.507-9.509-0.146-13.08C12.295,0.448,6.55,0.448,2.956,3.964z M14.395,9.004c0.829-0.052,1.549,0.58,1.6,1.411	c0.056,0.83-0.58,1.547-1.408,1.6c-0.065,0.005-0.126,0.005-0.189,0h-3.397v3.39c0.002,0.828-0.669,1.504-1.5,1.506	c-0.001,0-0.004,0-0.005,0c-0.831,0.003-1.506-0.671-1.507-1.499c0-0.002,0-0.006,0-0.008v-3.392H4.602 C3.77,12.064,3.052,11.433,3,10.602C2.947,9.771,3.58,9.055,4.411,9.003C4.473,9,4.538,9,4.602,9.003H7.99V5.618 c-0.026-0.833,0.626-1.53,1.459-1.554c0.834-0.028,1.531,0.626,1.554,1.458c0.003,0.031,0.003,0.063,0,0.095v3.389L14.395,9.004zM2.956,3.964c-3.652,3.57-3.717,9.429-0.146,13.08c3.571,3.653,9.429,3.72,13.081,0.146c0.051-0.047,0.1-0.097,0.146-0.146 c3.571-3.651,3.507-9.509-0.146-13.08C12.295,0.448,6.55,0.448,2.956,3.964z M14.395,9.004c0.829-0.052,1.549,0.58,1.6,1.411	c0.056,0.83-0.58,1.547-1.408,1.6c-0.065,0.005-0.126,0.005-0.189,0h-3.397v3.39c0.002,0.828-0.669,1.504-1.5,1.506	c-0.001,0-0.004,0-0.005,0c-0.831,0.003-1.506-0.671-1.507-1.499c0-0.002,0-0.006,0-0.008v-3.392H4.602 C3.77,12.064,3.052,11.433,3,10.602C2.947,9.771,3.58,9.055,4.411,9.003C4.473,9,4.538,9,4.602,9.003H7.99V5.618 c-0.026-0.833,0.626-1.53,1.459-1.554c0.834-0.028,1.531,0.626,1.554,1.458c0.003,0.031,0.003,0.063,0,0.095v3.389L14.395,9.004z')
				]),
			_List_Nil)
		]));
var $author$project$View$tt = F2(
	function (translations, path) {
		return $elm$html$Html$text(
			A2($author$project$Enectiva$I18n$t, translations, path));
	});
var $author$project$Plans$newFloorPlanButton = F3(
	function (translations, selection, drop) {
		var cls = $elm$html$Html$Attributes$class('flex items-center gap-2 w-full');
		var wrapper = $author$project$SelectionState$isSelected(selection) ? $elm$html$Html$div(
			_List_fromArray(
				[cls])) : $elm$html$Html$button(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Events$onClick(
					$author$project$Plans$FloorPlanButtonClicked($author$project$Plans$New)),
					cls
				]));
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Plans$floorPlanDnD.fv,
					$author$project$Plans$New,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('h-8 bg-grey-500'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'hidden',
											!_Utils_eq(
												drop,
												$elm$core$Maybe$Just($author$project$Plans$New)))
										]))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Plans$navigationItemClass(selection)
								]),
							_List_fromArray(
								[
									wrapper(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('add-icon fast-colors-transition w-5 h-5 hover:text-green-600')
												]),
											_List_fromArray(
												[$author$project$SvgIcons$plus])),
											A2($author$project$View$tt, translations, 'plan_js_new_upload_title')
										]))
								]))
						]))
				]));
	});
var $author$project$Plans$floorPlanListItemView = F3(
	function (translations, maybeOrder, _v0) {
		var selection = _v0.a;
		var floorPlan = _v0.b;
		var _v1 = _Utils_Tuple2(floorPlan, maybeOrder);
		switch (_v1.a.$) {
			case 0:
				if ((!_v1.b.$) && (!_v1.b.a.$)) {
					var fp = _v1.a.a;
					var draggable = _v1.b.a.a;
					return _Utils_eq(
						$author$project$DnD$getDragMeta(draggable),
						$elm$core$Maybe$Just(fp)) ? $author$project$Enectiva$View$nothing : A3(
						$author$project$Plans$floorPlanListItemViewHelp,
						$author$project$DnD$getDropMeta(draggable),
						selection,
						fp);
				} else {
					var fp = _v1.a.a;
					return A3($author$project$Plans$floorPlanListItemViewHelp, $elm$core$Maybe$Nothing, selection, fp);
				}
			case 1:
				var _v2 = _v1.a;
				var fp = _v2.b;
				return A3($author$project$Plans$floorPlanListItemViewHelp, $elm$core$Maybe$Nothing, selection, fp);
			default:
				if ((!_v1.b.$) && (!_v1.b.a.$)) {
					var draggable = _v1.b.a.a;
					return A3(
						$author$project$Plans$newFloorPlanButton,
						translations,
						selection,
						$author$project$DnD$getDropMeta(draggable));
				} else {
					return A3($author$project$Plans$newFloorPlanButton, translations, selection, $elm$core$Maybe$Nothing);
				}
		}
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Plans$floorPlanListView = F3(
	function (translations, order, floorPlans) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('space-y-1')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Plans$floorPlanListItemView, translations, order),
				floorPlans));
	});
var $author$project$SelectList$AfterSelected = 2;
var $author$project$SelectList$BeforeSelected = 0;
var $author$project$SelectList$Selected = 1;
var $author$project$SelectList$mapBy = F2(
	function (transform, _v0) {
		var beforeSel = _v0.a;
		var sel = _v0.b;
		var afterSel = _v0.c;
		return A3(
			$author$project$SelectList$SelectList,
			A2(
				$elm$core$List$map,
				transform(0),
				beforeSel),
			A2(transform, 1, sel),
			A2(
				$elm$core$List$map,
				transform(2),
				afterSel));
	});
var $author$project$Plans$floorPlansToList = F3(
	function (unselectedFn, selectedFn, selectList) {
		return $author$project$SelectList$toList(
			A2(
				$author$project$SelectList$mapBy,
				F2(
					function (position, floorPlan) {
						if (position === 1) {
							return selectedFn(floorPlan);
						} else {
							return unselectedFn(floorPlan);
						}
					}),
				selectList));
	});
var $author$project$Plans$DeleteCancellationButtonClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Plans$DeleteConfirmationButtonClicked = function (a) {
	return {$: 5, a: a};
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Plans$deleteDialog = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('absolute top-0 left-0 z-20 w-full h-full bg-white-transparent flex flex-col items-center justify-center')
			]),
		$elm$core$List$singleton(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('space-y-2 w-96 opacity-100 bg-white p-3 rounded shadow')
					]),
				children)));
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Plans$deleteConfirmationView = F2(
	function (translations, id) {
		return $author$project$Plans$deleteDialog(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-xl text-grey-600')
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'plan.confirm_delete')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-grey-600 py-1')
						]),
					_List_fromArray(
						[
							A2($author$project$View$tt, translations, 'plan.delete_explanation')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex gap-2 justify-end')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('neutral-button'),
									$elm$html$Html$Events$onClick(
									$author$project$Plans$DeleteCancellationButtonClicked(
										$author$project$Plans$Persisted(id))),
									$elm$html$Html$Attributes$id($author$project$Plans$cancelDeleteId)
								]),
							_List_fromArray(
								[
									A2($author$project$View$tt, translations, 'cancel')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('button'),
									$elm$html$Html$Attributes$class('dangerous-button'),
									$elm$html$Html$Events$onClick(
									$author$project$Plans$DeleteConfirmationButtonClicked(
										$author$project$Plans$Persisted(id)))
								]),
							_List_fromArray(
								[
									A2($author$project$View$tt, translations, 'plan_js_schema_delete')
								]))
						]))
				]));
	});
var $author$project$Plans$DeletePlanButtonClicked = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$SvgIcons$trash = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$x('0px'),
			$elm$svg$Svg$Attributes$y('0px'),
			$elm$svg$Svg$Attributes$width('17.98px'),
			$elm$svg$Svg$Attributes$height('21px'),
			$elm$svg$Svg$Attributes$viewBox('0 0 17.98 21'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M6.622,0.5h4.532c0.49,0,0.889,0.398,0.889,0.889v0.89h4.444c0.491,0,0.89,0.397,0.89,0.889v0.889 c0,0.491-0.396,0.889-0.89,0.889H1.289c-0.491,0-0.89-0.397-0.89-0.889v-0.89c0-0.491,0.396-0.889,0.89-0.889h4.444v-0.89 C5.734,0.898,6.131,0.5,6.622,0.5z M2.11,18.029C2.213,19.423,3.409,20.5,4.806,20.5h8.164c1.396,0,2.594-1.077,2.695-2.471V6.721 H2.11V18.029z')
				]),
			_List_Nil)
		]));
var $author$project$Plans$deleteFloorPlanButton = F2(
	function (translations, _v0) {
		var id = _v0.fM;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('button'),
					$elm$html$Html$Attributes$class('w-6 h-6 area-icon delete-icon'),
					$elm$html$Html$Events$onClick(
					$author$project$Plans$DeletePlanButtonClicked(
						$author$project$Plans$Persisted(id))),
					$elm$html$Html$Attributes$title(
					A2($author$project$Enectiva$I18n$t, translations, 'plan_js_schema_delete'))
				]),
			_List_fromArray(
				[$author$project$SvgIcons$trash]));
	});
var $author$project$Plans$deletionErrorView = $author$project$Plans$deleteDialog(
	$elm$core$List$singleton(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-red-800 text-xl text-center')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('error deleting the plan')
				]))));
var $author$project$Plans$NameChanged = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Spinner$container = $elm$html$Html$Attributes$class('relative');
var $elm$html$Html$input = _VirtualDom_node('input');
var $author$project$Enectiva$ValidatedValue$mapError = F3(
	function (success, error, str) {
		if (str.$ === 2) {
			var err = str.b;
			return error(err);
		} else {
			return success(0);
		}
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$View$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Plans$nameInputAndError = F3(
	function (translations, msg, name) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(
						$author$project$Enectiva$ValidatedValue$value(name)),
						$elm$html$Html$Attributes$placeholder(
						A2($author$project$Enectiva$I18n$t, translations, 'activerecord.attributes.plan.name')),
						$author$project$View$onChange(msg),
						$elm$html$Html$Attributes$id($author$project$Plans$nameInputId),
						$elm$html$Html$Attributes$class('textfield')
					]),
				_List_Nil),
				A3(
				$author$project$Enectiva$ValidatedValue$mapError,
				$elm$core$Basics$always($author$project$Enectiva$View$nothing),
				function (err) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(err)
							]));
				},
				name)
			]);
	});
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$Enectiva$Spinner$colours = {
	dR: 2100,
	dq: A3($avh4$elm_color$Color$rgb255, 0, 90, 171),
	dw: A3($avh4$elm_color$Color$rgb255, 244, 122, 55),
	e8: A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$elm$html$Html$div(_List_Nil))
};
var $author$project$Enectiva$Spinner$cssColorString = F2(
	function (kind, values) {
		return kind + ('(' + (A2($elm$core$String$join, ', ', values) + ')'));
	});
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {hj: a, hp: b, hW: g, iz: r};
};
var $author$project$Enectiva$Spinner$colorToCssRgba = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(color);
	var red = _v0.iz;
	var green = _v0.hW;
	var blue = _v0.hp;
	var alpha = _v0.hj;
	return A2(
		$author$project$Enectiva$Spinner$cssColorString,
		'rgba',
		_List_fromArray(
			[
				$elm$core$String$fromFloat(red * 255),
				$elm$core$String$fromFloat(green * 255),
				$elm$core$String$fromFloat(blue * 255),
				$elm$core$String$fromFloat(alpha)
			]));
};
var $elm$svg$Svg$style = $elm$svg$Svg$trustedNode('style');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Enectiva$Spinner$style = function (settings) {
	return A2(
		$elm$svg$Svg$style,
		_List_Nil,
		_List_fromArray(
			[
				$elm$svg$Svg$text(
				'path.spinner-punk{fill:' + ($author$project$Enectiva$Spinner$colorToCssRgba(settings.dw) + ';opacity:0}'))
			]));
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $author$project$Enectiva$Spinner$letterE = function (settings) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('m19.315,27.286194c0,-7.673 -4.763,-10.848 -9.525,-10.848 -5.557,0 -9.79,4.233 -9.79,9.525 0,6.879 5.027,10.054 9.79,10.054 5.027,0 8.995,-4.498 8.995,-6.615H16.14c0,1.323 -2.911,4.234 -6.35,4.234 -2.911,0 -7.144,-1.588 -7.144,-6.35h16.669m-2.646,-2.382c0,-3.175 -2.646,-6.085 -6.879,-6.085 -3.44,0 -7.144,2.646 -7.144,6.085h14.023'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$fill(
				$author$project$Enectiva$Spinner$colorToCssRgba(settings.dq)),
				$elm$svg$Svg$Attributes$class('e')
			]),
		_List_Nil);
};
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$Attributes$begin = _VirtualDom_attribute('begin');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$keyTimes = _VirtualDom_attribute('keyTimes');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Enectiva$Spinner$punk = F4(
	function (settings, index, path, begin) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(path),
					$elm$svg$Svg$Attributes$class('spinner-punk')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$animate,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$attributeName('opacity'),
							$elm$svg$Svg$Attributes$values('0;1;0;0'),
							$elm$svg$Svg$Attributes$keyTimes('0;0.2;0.4;1'),
							$elm$svg$Svg$Attributes$dur(
							$elm$core$String$fromFloat(settings.dR) + 'ms'),
							$elm$svg$Svg$Attributes$repeatCount('indefinite'),
							$elm$svg$Svg$Attributes$begin(begin)
						]),
					_List_Nil)
				]));
	});
var $author$project$Enectiva$Spinner$svgElements = function (settings) {
	return _List_fromArray(
		[
			$author$project$Enectiva$Spinner$letterE(settings),
			A4($author$project$Enectiva$Spinner$punk, settings, 0, 'm2.5 8.6c0 2.4 0 4.9 0 7.3 0.3-0.3 2.2-1.3 2.8-1.3 0-2 0-4 0-6z', '0s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 1, 'm8.5 4.5c0 3.2 0 6.4 0 9.5 1.3-0.1 1.6-0.1 2.8 0 0-3.2 0-6.4 0-9.5z', '0.35s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 2, 'm14.5 0c0 4.9 0 9.7 0 14.6 0.6 0 2.5 1 2.8 1.3 0-5.3 0-10.6 0-15.9z', '0.7s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 5, 'm2.9 36.4c0 2.1 0 4.3 0 6.4h2.7v-5.1c-0.3 0-2.4-1.1-2.7-1.3z', '1.75s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 4, 'm8.6 38.2c0 1.6 0 3 0 4.5h2.7c0-1.6 0-3.1 0-4.5-0.9 0.2-1.8 0.2-2.7 0z', '1.4s'),
			A4($author$project$Enectiva$Spinner$punk, settings, 3, 'm16.9 36.4c-0.3 0.3-2.4 1.3-2.7 1.3 0 1.8 0 3.5 0 5.1h2.7c0-2.2 0-4.4 0-6.4z', '1.05s')
		]);
};
var $author$project$Enectiva$Spinner$full = F2(
	function (settings, show) {
		return show ? settings.e8(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height('100%'),
						$elm$svg$Svg$Attributes$viewBox('0 0 20 43')
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Enectiva$Spinner$style(settings),
					$author$project$Enectiva$Spinner$svgElements(settings)))) : $elm$svg$Svg$text('');
	});
var $author$project$Enectiva$View$viewIf = F2(
	function (view, condition) {
		return condition ? view(0) : $elm$html$Html$text('');
	});
var $author$project$Spinner$overlay = $author$project$Enectiva$View$viewIf(
	function (_v0) {
		var _default = $author$project$Enectiva$Spinner$colours;
		var opts = _Utils_update(
			_default,
			{
				e8: function (svg) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bg-white opacity-70 absolute top-0 left-0 w-full h-full z-50'),
								A2($elm$html$Html$Attributes$attribute, 'data-spinner-target', 'overlay')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('absolute left-1/2 top-1/10 h-8/10 max-h-12')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('h-full relative -left-1/2')
											]),
										_List_fromArray(
											[svg]))
									]))
							]));
				}
			});
		return A2($author$project$Enectiva$Spinner$full, opts, true);
	});
var $author$project$Plans$floorPlanName = F2(
	function (translations, _v0) {
		var id = _v0.fM;
		var name = _v0.f9;
		var updateRequest = _v0.cY;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Spinner$container]),
			_Utils_ap(
				A3(
					$author$project$Plans$nameInputAndError,
					translations,
					$author$project$Plans$NameChanged(
						$author$project$Plans$Persisted(id)),
					name),
				_List_fromArray(
					[
						function () {
						switch (updateRequest.$) {
							case 1:
								return $author$project$Spinner$overlay(true);
							case 2:
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('error saving the plane')
										]));
							default:
								return $author$project$Enectiva$View$nothing;
						}
					}()
					])));
	});
var $author$project$Plans$headerView = $elm$html$Html$div(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('flex items-center gap-2'),
			A2($elm$html$Html$Attributes$style, 'grid-area', 'header')
		]));
var $author$project$Plans$NewPlanPreviewLoaded = function (a) {
	return {$: 22, a: a};
};
var $author$project$Enectiva$I18n$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Enectiva$I18n$AsFloat = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$Enectiva$I18n$escapeDelimiter = function (delimiter) {
	if (delimiter === '.') {
		return '\\.';
	} else {
		return delimiter;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {h_: index, h6: match, dn: number, gR: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{hu: false, ie: false},
		string);
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $elm$regex$Regex$never = _Regex_never;
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$core$String$reverse = _String_reverse;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $author$project$Enectiva$I18n$formatIntegerPartOfNumber = F2(
	function (delimiter, number) {
		var escapedDelimiter = $author$project$Enectiva$I18n$escapeDelimiter(delimiter);
		return A3(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('^' + (escapedDelimiter + ('?(.+?)' + (escapedDelimiter + '?$'))))),
			function (_v0) {
				var submatches = _v0.gR;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						$elm$core$List$head(submatches)));
			},
			A3(
				$elm$core$List$foldl,
				F2(
					function (group, acc) {
						var segment = $elm$core$String$fromList(
							$elm$core$List$reverse(group));
						return _Utils_ap(
							segment,
							_Utils_ap(delimiter, acc));
					}),
				'',
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					3,
					$elm$core$String$toList(
						$elm$core$String$reverse(
							$elm$core$String$fromInt(
								$elm$core$Basics$abs(number) | 0))))));
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Enectiva$I18n$formatNumberWithPrecision = F3(
	function (translations, precision, number) {
		var sign = (number < 0) ? '-' : '';
		var delimiter = A2($author$project$Enectiva$I18n$t, translations, 'number.format.delimiter');
		if (!precision.$) {
			return _Utils_ap(
				sign,
				A2($author$project$Enectiva$I18n$formatIntegerPartOfNumber, delimiter, number));
		} else {
			var decimalPlaces = precision.a;
			var shift = A2($elm$core$Basics$pow, 10, decimalPlaces);
			var shiftedNumber = $elm$core$Basics$round(
				$elm$core$Basics$abs(number * shift));
			var decimalPart = A3(
				$elm$core$String$padRight,
				decimalPlaces,
				'0',
				A3(
					$elm$core$String$padLeft,
					decimalPlaces,
					'0',
					$elm$core$String$fromInt(
						function (n) {
							return A2($elm$core$Basics$modBy, shift, n);
						}(shiftedNumber))));
			return _Utils_ap(
				sign,
				_Utils_ap(
					A2($author$project$Enectiva$I18n$formatIntegerPartOfNumber, delimiter, (shiftedNumber / shift) | 0),
					_Utils_ap(
						A2($author$project$Enectiva$I18n$t, translations, 'number.format.separator'),
						decimalPart)));
		}
	});
var $author$project$Enectiva$I18n$formatNumber = function (translations) {
	return A2(
		$author$project$Enectiva$I18n$formatNumberWithPrecision,
		translations,
		$author$project$Enectiva$I18n$AsFloat(2));
};
var $author$project$Ports$RectangleDimensions = F2(
	function (width, height) {
		return {au: height, bn: width};
	});
var $author$project$Plans$imageNaturalDimensionsDecoder = A2(
	$elm$json$Json$Decode$field,
	'target',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'naturalHeight',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'naturalWidth',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Ports$RectangleDimensions))));
var $author$project$Plans$DragFileEnter = {$: 18};
var $author$project$Plans$DragFileLeave = {$: 19};
var $author$project$Plans$PickImageButtonClicked = {$: 16};
var $elm_community$basics_extra$Basics$Extra$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$View$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2(
				$elm$json$Json$Decode$map,
				A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Tuple$pair, true),
				decoder));
	});
var $elm$file$File$decoder = _File_decoder;
var $author$project$Plans$imageDroppedDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files', '0']),
	A2($elm$json$Json$Decode$map, $author$project$Plans$ImageSelected, $elm$file$File$decoder));
var $elm$core$Basics$not = _Basics_not;
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Plans$imageUploadElements = F2(
	function (translations, fileCanBeDropped) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('p-4 border-4 border-dashed rounded mb-4'),
						$elm$html$Html$Attributes$class('min-h-64 transition transition-border duration-100 ease-in-out'),
						$elm$html$Html$Attributes$class('flex flex-col justify-center items-center'),
						$elm$html$Html$Attributes$class('hover:border-grey-600'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('border-grey-600', fileCanBeDropped),
								_Utils_Tuple2('border-grey-300', !fileCanBeDropped)
							])),
						A2(
						$author$project$View$hijackOn,
						'dragenter',
						$elm$json$Json$Decode$succeed($author$project$Plans$DragFileEnter)),
						A2(
						$author$project$View$hijackOn,
						'dragover',
						$elm$json$Json$Decode$succeed($author$project$Plans$DragFileEnter)),
						A2(
						$author$project$View$hijackOn,
						'dragleave',
						$elm$json$Json$Decode$succeed($author$project$Plans$DragFileLeave)),
						A2($author$project$View$hijackOn, 'drop', $author$project$Plans$imageDroppedDecoder)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xl text-center text-grey-600')
							]),
						_List_fromArray(
							[
								A2($author$project$View$tt, translations, 'plan.drag_an_image_here')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-center text-grey-600 py-1')
							]),
						_List_fromArray(
							[
								A2($author$project$View$tt, translations, 'or')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('button'),
								$elm$html$Html$Attributes$class('neutral-button'),
								$elm$html$Html$Events$onClick($author$project$Plans$PickImageButtonClicked)
							]),
						_List_fromArray(
							[
								A2($author$project$View$tt, translations, 'plan.select_an_image')
							]))
					]))
			]);
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Plans$inMB = A2(
	$elm$core$Basics$composeR,
	$elm$core$Basics$toFloat,
	$elm$core$Basics$fdiv(1024 * 1024));
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Enectiva$I18n$applyOption = function (option) {
	if (!option.$) {
		var placeholder = option.a;
		var value = option.b;
		return A2(
			$elm$regex$Regex$replace,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$regex$Regex$never,
				$elm$regex$Regex$fromString('%{' + (placeholder + '}'))),
			$elm$core$Basics$always(value));
	} else {
		return $elm$core$Basics$identity;
	}
};
var $author$project$Enectiva$I18n$one = 'one';
var $author$project$Enectiva$I18n$other = 'other';
var $author$project$Enectiva$I18n$fallbackPluralizationFn = function (cnt) {
	if (cnt === 1) {
		return $author$project$Enectiva$I18n$one;
	} else {
		return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$few = 'few';
var $author$project$Enectiva$I18n$czechPluralizationFn = function (cnt) {
	switch (cnt) {
		case 1:
			return $author$project$Enectiva$I18n$one;
		case 2:
			return $author$project$Enectiva$I18n$few;
		case 3:
			return $author$project$Enectiva$I18n$few;
		case 4:
			return $author$project$Enectiva$I18n$few;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$frenchPluralizationFn = function (cnt) {
	switch (cnt) {
		case 0:
			return $author$project$Enectiva$I18n$one;
		case 1:
			return $author$project$Enectiva$I18n$one;
		default:
			return $author$project$Enectiva$I18n$other;
	}
};
var $author$project$Enectiva$I18n$slovakPluralizationFn = $author$project$Enectiva$I18n$czechPluralizationFn;
var $author$project$Enectiva$I18n$pluralizationFns = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('cs', $author$project$Enectiva$I18n$czechPluralizationFn),
			_Utils_Tuple2('sk', $author$project$Enectiva$I18n$slovakPluralizationFn),
			_Utils_Tuple2('fr', $author$project$Enectiva$I18n$frenchPluralizationFn),
			_Utils_Tuple2(
			'hu',
			$elm$core$Basics$always($author$project$Enectiva$I18n$other))
		]));
var $author$project$Enectiva$I18n$countToKeyPathSegment = F2(
	function (_v0, cnt) {
		var l = _v0.a;
		return A3(
			$elm$core$Basics$apR,
			A2($elm$core$Dict$get, l, $author$project$Enectiva$I18n$pluralizationFns),
			$elm$core$Maybe$withDefault($author$project$Enectiva$I18n$fallbackPluralizationFn),
			$elm$core$Basics$abs(cnt));
	});
var $author$project$Enectiva$I18n$providedCount = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (o) {
					if (o.$ === 1) {
						var cnt = o.a;
						return $elm$core$Maybe$Just(
							$elm$core$Maybe$Just(cnt));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				options)));
};
var $author$project$Enectiva$I18n$tt = F3(
	function (translations, key, options) {
		var _v0 = $author$project$Enectiva$I18n$providedCount(options);
		if (!_v0.$) {
			var cnt = _v0.a;
			var _v1 = A2(
				$author$project$Enectiva$I18n$tHelp,
				translations,
				_Utils_ap(
					$author$project$Enectiva$I18n$keyToKeyPath(key),
					_List_fromArray(
						[
							A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, cnt)
						])));
			if (_v1.$ === 1) {
				var _v2 = A2(
					$author$project$Enectiva$I18n$tHelp,
					translations,
					_Utils_ap(
						$author$project$Enectiva$I18n$keyToKeyPath(key),
						_List_fromArray(
							[
								A2($author$project$Enectiva$I18n$countToKeyPathSegment, translations, 1)
							])));
				if (_v2.$ === 1) {
					return A2($author$project$Enectiva$I18n$t, translations, key);
				} else {
					var localized = _v2.a;
					return localized;
				}
			} else {
				var localized = _v1.a;
				return A2(
					$author$project$Enectiva$I18n$applyOption,
					A2(
						$author$project$Enectiva$I18n$Placeholder,
						'count',
						$elm$core$String$fromInt(cnt)),
					localized);
			}
		} else {
			return A3(
				$elm$core$List$foldl,
				$author$project$Enectiva$I18n$applyOption,
				A2($author$project$Enectiva$I18n$t, translations, key),
				options);
		}
	});
var $author$project$Plans$imageUploadView = F2(
	function (translations, _v0) {
		var name = _v0.f9;
		var image = _v0.T;
		var fileCanBeDropped = _v0.cr;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'grid-area', 'header / plan / sidebar / sidebar'),
					$author$project$Spinner$container
				]),
			function () {
				switch (image.$) {
					case 0:
						return A2($author$project$Plans$imageUploadElements, translations, fileCanBeDropped);
					case 3:
						var n = image.a;
						var size = image.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center text-lg text-red-800 mb-2 font-semibold')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3(
											$author$project$Enectiva$I18n$tt,
											translations,
											'plan.upload_too_big',
											_List_fromArray(
												[
													A2(
													$author$project$Enectiva$I18n$Placeholder,
													'limit',
													$elm$core$String$fromInt($author$project$Plans$maxAcceptedFileSizeInMegabytes)),
													A2($author$project$Enectiva$I18n$Placeholder, 'filename', n),
													A2(
													$author$project$Enectiva$I18n$Placeholder,
													'size',
													A2(
														$author$project$Enectiva$I18n$formatNumber,
														translations,
														$author$project$Plans$inMB(size)))
												])))
									])),
							A2($author$project$Plans$imageUploadElements, translations, fileCanBeDropped));
					case 1:
						return _List_fromArray(
							[
								$author$project$Plans$headerView(
								A3(
									$author$project$Plans$nameInputAndError,
									translations,
									$author$project$Plans$NameChanged($author$project$Plans$New),
									name)),
								$author$project$Spinner$overlay(true)
							]);
					default:
						var preview = image.b;
						return _List_fromArray(
							[
								$author$project$Plans$headerView(
								A3(
									$author$project$Plans$nameInputAndError,
									translations,
									$author$project$Plans$NameChanged($author$project$Plans$New),
									name)),
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(preview),
										$elm$html$Html$Attributes$class('w-full'),
										A2(
										$elm$html$Html$Events$on,
										'load',
										A2($elm$json$Json$Decode$map, $author$project$Plans$NewPlanPreviewLoaded, $author$project$Plans$imageNaturalDimensionsDecoder))
									]),
								_List_Nil),
								$author$project$Spinner$overlay(true)
							]);
				}
			}());
	});
var $author$project$Plans$draggedObjectCursorOffset = {hb: 0, hc: -43};
var $author$project$Plans$dataSeriesPseudoIcon = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('w-4 h-4 bg-green-400 rounded-full rounded-tl-none grow-0 relative')
		]),
	_List_Nil);
var $author$project$Plans$dsIcon = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('mr-2 p-1 flex flex-row-reverse relative inline-block text-center bg-white'),
			$elm$html$Html$Attributes$class('border-2 border-green-400 border-solid border rounded-full rounded-tl-none'),
			$elm$html$Html$Attributes$class('group-hover:shadow-md')
		]),
	_List_fromArray(
		[$author$project$Plans$dataSeriesPseudoIcon]));
var $author$project$SvgIcons$energyIcon = F6(
	function (cls, iconWidth, iconHeight, children, maybeClass, maybeWidth) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('energy-icon'),
					$elm$svg$Svg$Attributes$class(cls),
					$elm$svg$Svg$Attributes$class(
					A2($elm$core$Maybe$withDefault, '', maybeClass)),
					$elm$svg$Svg$Attributes$viewBox(
					'0 0 ' + ($elm$core$String$fromFloat(iconWidth) + (' ' + $elm$core$String$fromFloat(iconHeight)))),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(
						A2($elm$core$Maybe$withDefault, iconWidth, maybeWidth))),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromFloat(
						A2($elm$core$Maybe$withDefault, iconHeight, maybeWidth)))
				]),
			children);
	});
var $author$project$SvgIcons$co = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	21.75,
	23.5,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12.037,23H9.67v-2.445l-1.621,1.541l-1.628-1.712l3.249-3.085v-3.506l-3.002,1.734l-1.056,4.39l-2.296-0.556l0.53-2.207 l-2.137,1.234l-1.185-2.052l2.117-1.22l-2.143-0.635l0.668-2.265l4.296,1.271l3.045-1.758L5.496,9.991l-4.33,1.281L0.498,9.007 l2.178-0.644L0.537,7.127l1.185-2.05l2.117,1.224L3.316,4.126l2.296-0.553l1.047,4.356L9.67,9.667V6.18L6.421,3.095l1.628-1.71 L9.67,2.924V0.5h2.367v2.449l1.646-1.564l1.629,1.71l-3.275,3.11v3.488l3.055-1.764l1.047-4.356l2.295,0.553l-0.521,2.175 l2.098-1.213l1.184,2.051l-2.118,1.224l2.177,0.644l-0.668,2.265l-4.33-1.281l-3.011,1.738l3.045,1.757l4.296-1.269l0.668,2.263 l-2.145,0.636l2.1,1.211l-1.184,2.051l-2.119-1.226l0.529,2.209l-2.295,0.556l-1.057-4.39l-3.045-1.76v3.506l3.275,3.11l-1.629,1.71 l-1.646-1.564V23z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$el = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	14.87,
	24,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('m 4.973,1.9999455 c -0.36,0 -0.678,0.225 -0.783,0.555 L 0.537,12.767946 c -0.133,0.416 0.109,0.855 0.543,0.982 0.078,0.023 0.16,0.036 0.241,0.036 h 2.767 l -0.752,9.366 c -0.034,0.436 0.303,0.812 0.755,0.846 0.291,0.02 0.571,-0.107 0.738,-0.339 l 9.397,-12.571 c 0.258,-0.357 0.159,-0.847 -0.211,-1.0930004 -0.143,-0.089 -0.301,-0.139 -0.467,-0.139 H 9.666 l 3.881,-6.7200001 c 0.203,-0.388 0.039,-0.859 -0.367,-1.055 -0.114,-0.053 -0.239,-0.081 -0.368,-0.081 z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$ga = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	17.34,
	23,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M 7.983,0.50455415 C 7.85,0.53055415 7.746,0.63555416 7.729,0.76955416 6.952,5.2625542 5.221,7.1065542 3.611,8.7925542 2.003,10.476554 0.499,12.045554 0.499,15.651554 c 0,1.74 0.771,3.201 1.924,4.342 1.154,1.138 2.688,1.961 4.263,2.482 0.166,0.054 0.343,-0.038 0.395,-0.205 0.031,-0.098 0.013,-0.205 -0.05,-0.286 -1.541,-1.85 -1.971,-3.185 -1.935,-4.27 0.032,-0.956 0.443,-1.763 0.864,-2.591 0.622,0.5 1.163,0.914 1.453,1.1 0.177,0.111 0.299,0.183 0.383,0.226 0.084,0.042 0.158,0.069 0.158,0.069 0.09,0.025 0.187,0.012 0.264,-0.041 0,0 0.627,-0.432 1.13,-1.382 0.421,-0.798 0.749,-2.007 0.657,-3.624 2.023,2.204 2.773,4.091 2.75,5.683 -0.03,2.084 -1.282,3.749 -2.418,4.792 -0.131,0.11 -0.149,0.31 -0.037,0.441 0.071,0.086 0.182,0.127 0.296,0.106 3.244,-0.455 6.245,-3.308 6.245,-6.902 0,-2.544 -0.439,-4.794 -1.74,-7.1539998 -1.299,-2.361 -3.449,-4.825 -6.854,-7.85500004 -0.071,-0.064 -0.169,-0.092 -0.264,-0.078 z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$hca = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	20.77,
	21,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.483,2.175C5.26,1.746,5.036,1.439,4.634,0.947C4.356,0.578,3.906,0.453,3.451,0.516c-0.677,0.183-1.067,0.86-0.958,1.597 l0.112,0.555c0.059,0.184,0.169,0.49,0.225,0.799c0.059,0.307,0.112,0.553,0.171,0.86C3.058,4.88,3.058,5.433,2.942,5.988 C2.83,6.54,2.721,7.032,2.437,7.583L1.535,9.674c-0.285,0.737-0.567,1.536-0.793,2.457c-0.168,0.923-0.281,1.905-0.225,2.829 c0.113,1.964,0.959,3.686,1.976,4.978c0.337,0.43,0.903,0.614,1.414,0.43c0.675-0.246,1.012-1.045,0.787-1.844v-0.063 c-0.45-1.351-0.734-2.518-0.619-3.626c0.059-1.106,0.396-2.211,0.961-3.563C5.26,10.596,5.6,9.919,5.825,9.18 c0.278-0.798,0.563-1.843,0.563-2.825c0.058-0.983-0.114-1.967-0.394-2.889C5.878,3.037,5.709,2.605,5.483,2.175z M12.437,2.175 c-0.229-0.43-0.452-0.736-0.848-1.229c-0.285-0.308-0.732-0.494-1.187-0.369C9.728,0.762,9.332,1.439,9.445,2.175l0.109,0.553 c0.059,0.184,0.173,0.492,0.228,0.8c0.055,0.308,0.109,0.554,0.168,0.86c0.058,0.555,0.058,1.105-0.059,1.658 c-0.109,0.555-0.223,1.045-0.501,1.6L8.484,9.735c-0.284,0.737-0.563,1.538-0.79,2.458c-0.173,0.922-0.284,1.844-0.227,2.827 C7.579,16.988,8.425,18.71,9.445,20c0.337,0.431,0.901,0.613,1.412,0.431c0.675-0.247,1.011-1.045,0.785-1.845v-0.062 c-0.448-1.352-0.729-2.52-0.618-3.626c0.059-1.107,0.396-2.214,0.961-3.565c0.223-0.676,0.565-1.352,0.79-2.089 c0.28-0.8,0.565-1.845,0.565-2.828c0.052-0.982-0.111-1.967-0.396-2.888C12.827,3.037,12.665,2.605,12.437,2.175z M19.916,3.528 c-0.175-0.433-0.343-0.86-0.565-1.29c-0.227-0.432-0.453-0.738-0.848-1.231c-0.284-0.367-0.733-0.49-1.186-0.429 c-0.679,0.185-1.076,0.861-0.962,1.598l0.114,0.553c0.057,0.184,0.169,0.492,0.227,0.8c0.056,0.308,0.112,0.554,0.167,0.86 c0.059,0.555,0.059,1.105-0.055,1.658c-0.112,0.555-0.23,1.045-0.509,1.6l-0.904,2.089c-0.282,0.737-0.562,1.538-0.787,2.458 c-0.17,0.922-0.281,1.906-0.226,2.827c0.108,1.968,0.957,3.69,1.973,4.979c0.341,0.431,0.908,0.613,1.414,0.431 c0.679-0.247,1.018-1.045,0.789-1.845v-0.062c-0.452-1.352-0.735-2.52-0.62-3.626c0.053-1.107,0.394-2.214,0.959-3.565 c0.227-0.676,0.564-1.352,0.79-2.089c0.284-0.8,0.566-1.845,0.566-2.828C20.31,5.433,20.199,4.388,19.916,3.528z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$he = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	20.77,
	21,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.483,2.175C5.26,1.746,5.036,1.439,4.634,0.947C4.356,0.578,3.906,0.453,3.451,0.516c-0.677,0.183-1.067,0.86-0.958,1.597 l0.112,0.555c0.059,0.184,0.169,0.49,0.225,0.799c0.059,0.307,0.112,0.553,0.171,0.86C3.058,4.88,3.058,5.433,2.942,5.988 C2.83,6.54,2.721,7.032,2.437,7.583L1.535,9.674c-0.285,0.737-0.567,1.536-0.793,2.457c-0.168,0.923-0.281,1.905-0.225,2.829 c0.113,1.964,0.959,3.686,1.976,4.978c0.337,0.43,0.903,0.614,1.414,0.43c0.675-0.246,1.012-1.045,0.787-1.844v-0.063 c-0.45-1.351-0.734-2.518-0.619-3.626c0.059-1.106,0.396-2.211,0.961-3.563C5.26,10.596,5.6,9.919,5.825,9.18 c0.278-0.798,0.563-1.843,0.563-2.825c0.058-0.983-0.114-1.967-0.394-2.889C5.878,3.037,5.709,2.605,5.483,2.175z M12.437,2.175 c-0.229-0.43-0.452-0.736-0.848-1.229c-0.285-0.308-0.732-0.494-1.187-0.369C9.728,0.762,9.332,1.439,9.445,2.175l0.109,0.553 c0.059,0.184,0.173,0.492,0.228,0.8c0.055,0.308,0.109,0.554,0.168,0.86c0.058,0.555,0.058,1.105-0.059,1.658 c-0.109,0.555-0.223,1.045-0.501,1.6L8.484,9.735c-0.284,0.737-0.563,1.538-0.79,2.458c-0.173,0.922-0.284,1.844-0.227,2.827 C7.579,16.988,8.425,18.71,9.445,20c0.337,0.431,0.901,0.613,1.412,0.431c0.675-0.247,1.011-1.045,0.785-1.845v-0.062 c-0.448-1.352-0.729-2.52-0.618-3.626c0.059-1.107,0.396-2.214,0.961-3.565c0.223-0.676,0.565-1.352,0.79-2.089 c0.28-0.8,0.565-1.845,0.565-2.828c0.052-0.982-0.111-1.967-0.396-2.888C12.827,3.037,12.665,2.605,12.437,2.175z M19.916,3.528 c-0.175-0.433-0.343-0.86-0.565-1.29c-0.227-0.432-0.453-0.738-0.848-1.231c-0.284-0.367-0.733-0.49-1.186-0.429 c-0.679,0.185-1.076,0.861-0.962,1.598l0.114,0.553c0.057,0.184,0.169,0.492,0.227,0.8c0.056,0.308,0.112,0.554,0.167,0.86 c0.059,0.555,0.059,1.105-0.055,1.658c-0.112,0.555-0.23,1.045-0.509,1.6l-0.904,2.089c-0.282,0.737-0.562,1.538-0.787,2.458 c-0.17,0.922-0.281,1.906-0.226,2.827c0.108,1.968,0.957,3.69,1.973,4.979c0.341,0.431,0.908,0.613,1.414,0.431 c0.679-0.247,1.018-1.045,0.789-1.845v-0.062c-0.452-1.352-0.735-2.52-0.62-3.626c0.053-1.107,0.394-2.214,0.959-3.565 c0.227-0.676,0.564-1.352,0.79-2.089c0.284-0.8,0.566-1.845,0.566-2.828C20.31,5.433,20.199,4.388,19.916,3.528z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$lf = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	23.93,
	22.5,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M3.527,7.357c0,0,2.992,3.304,2.992,4.888c0,1.582-1.34,2.867-2.992,2.867c-1.653,0-2.993-1.283-2.993-2.867 C0.535,10.662,3.527,7.357,3.527,7.357z M23.429,21.12L22.6,19.012c0.231-0.179,0.33-0.48,0.214-0.76l-3.292-7.833l0.604-0.739 c0.127-0.145,0.18-0.341,0.143-0.536c-0.038-0.196-0.159-0.362-0.325-0.454l-7.321-4.248c-0.252-0.144-0.582-0.11-0.804,0.066 l-1.563-1.184c-0.074-0.058-0.162-0.1-0.267-0.126L2.816,1.52C2.443,1.424,2.031,1.676,1.963,2.027L1.589,3.726 C1.51,4.075,1.743,4.429,2.106,4.514l5.898,1.375C8.1,5.958,8.465,6.237,8.929,6.591c0.149,0.115,0.288,0.22,0.422,0.323 C9.208,7.167,9.237,7.486,9.459,7.699l0.438,0.418L12,19.264c0.194,1.155,1.308,2.061,2.537,2.061h0.03 c0.367,0,0.726-0.073,1.067-0.219l2.699-1.158l0.039,0.109c0.088,0.266,0.351,0.45,0.647,0.458l0.797,2.028 C19.906,22.813,20.181,23,20.481,23c0.102,0,0.198-0.021,0.281-0.06l2.296-0.989C23.388,21.811,23.55,21.446,23.429,21.12z M15.396,18.36c-0.227,0.094-0.486-0.05-0.524-0.28l-1.02-5.179c0,0-0.104-0.496,0.358-0.602c0.463-0.104,1.037-0.233,1.037-0.233 l2.003,5.561L15.396,18.36z')
				]),
			_List_Nil)
		]));
var $author$project$SvgIcons$wa = A4(
	$author$project$SvgIcons$energyIcon,
	'',
	16.3,
	22.52,
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M8.476,1.155c-0.15-0.209-0.501-0.209-0.651,0L6.007,3.656C4.715,5.439,0.5,11.511,0.5,14.869 c0,4.221,3.435,7.65,7.649,7.65c4.219,0,7.649-3.433,7.649-7.65c0-3.358-4.22-9.432-5.51-11.213L8.476,1.155z')
				]),
			_List_Nil)
		]));
var $author$project$Types$energyIconWithOpts = F3(
	function (_class, size, energy) {
		switch (energy) {
			case 1:
				return A2($author$project$SvgIcons$el, _class, size);
			case 2:
				return A2($author$project$SvgIcons$ga, _class, size);
			case 3:
				return A2($author$project$SvgIcons$wa, _class, size);
			case 4:
				return A2($author$project$SvgIcons$he, _class, size);
			case 5:
				return A2($author$project$SvgIcons$co, _class, size);
			case 6:
				return A2($author$project$SvgIcons$hca, _class, size);
			case 7:
				return A2($author$project$SvgIcons$lf, _class, size);
			default:
				return $author$project$Enectiva$View$nothing;
		}
	});
var $author$project$Plans$energyToColorClass = function (energy) {
	switch (energy) {
		case 1:
			return 'bg-orange-600 border-orange-600';
		case 2:
			return 'bg-yellow-600 border-yellow-600';
		case 3:
			return 'bg-blue-600 border-blue-600';
		case 4:
			return 'bg-purple-600 border-purple-600';
		case 5:
			return 'bg-green-600 border-green-600';
		case 6:
			return 'bg-black border-black';
		case 7:
			return 'bg-teal-600 border-teal-600';
		default:
			return '';
	}
};
var $author$project$Plans$meterIcon = function (energy) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				$author$project$Plans$energyToColorClass(energy)),
				$elm$html$Html$Attributes$class('inline-block mr-2 p-1 relative text-center'),
				$elm$html$Html$Attributes$class('border-2 border-white border-solid border rounded-full rounded-tl-none'),
				$elm$html$Html$Attributes$class('group-hover:shadow-md')
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Types$energyIconWithOpts,
				$elm$core$Maybe$Just('w-4 h-4 text-white fill-current'),
				$elm$core$Maybe$Nothing,
				energy)
			]));
};
var $author$project$Plans$objectBeingMovedHelp = function (draggedObject) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('relative'),
				A2($elm$html$Html$Attributes$style, 'z-index', '4'),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				'-' + $author$project$Types$px($author$project$Plans$draggedObjectCursorOffset.hc - $author$project$Plans$counteractHardcodedValue)),
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				'-' + $author$project$Types$px($author$project$Plans$draggedObjectCursorOffset.hb - $author$project$Plans$counteractHardcodedValue))
			]),
		$elm$core$List$singleton(
			function (object) {
				if (!object.$) {
					var energy = object.c;
					return $author$project$Plans$meterIcon(energy);
				} else {
					return $author$project$Plans$dsIcon;
				}
			}(
				function () {
					if (!draggedObject.$) {
						var object = draggedObject.a;
						return object;
					} else {
						var _v1 = draggedObject.a;
						var object = _v1.b;
						return object;
					}
				}())));
};
var $author$project$Plans$objectBeingMoved = function (objectMove) {
	return A2($author$project$DnD$dragged, objectMove, $author$project$Plans$objectBeingMovedHelp);
};
var $author$project$Plans$FloorPlanImageLoaded = {$: 23};
var $author$project$Plans$OnPlan = {$: 0};
var $author$project$DnD$anythingDragged = function (_v0) {
	var model = _v0;
	if (!model.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Plans$dsBannerClass = $elm$html$Html$Attributes$class('h-6 py-1 px-2 relative');
var $author$project$Plans$dsIconWithValueBanner = F2(
	function (translations, dp) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('plans__dataseries-icon'),
					$elm$html$Html$Attributes$class('mr-2 flex shadow bg-white'),
					$elm$html$Html$Attributes$class('border-2 border-green-400 border-solid rounded-full rounded-tl-none')
				]),
			_List_fromArray(
				[
					$author$project$Plans$dataSeriesPseudoIcon,
					function () {
					_v0$2:
					while (true) {
						if (!dp.$) {
							if (!dp.a.$) {
								var val = dp.a.a;
								var unit = dp.b;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Plans$dsBannerClass]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Enectiva$I18n$formatNumber, translations, val) + (' ' + unit))
										]));
							} else {
								break _v0$2;
							}
						} else {
							if (!dp.a.$) {
								var val = dp.a.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[$author$project$Plans$dsBannerClass]),
									_List_fromArray(
										[
											$elm$html$Html$text(val)
										]));
							} else {
								break _v0$2;
							}
						}
					}
					return $author$project$Enectiva$View$nothing;
				}()
				]));
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Plans$objectDetailClass = $elm$html$Html$Attributes$class('hidden -mt-2 ml-4 bg-white rounded py-2 px-4 shadow cursor-default h-auto group-hover:block');
var $author$project$Plans$scaleCoordinates = F3(
	function (renderedImage, image, _v0) {
		var x = _v0.hb;
		var y = _v0.hc;
		return {
			hb: $elm$core$Basics$round((x / image.bn) * renderedImage.bn),
			hc: $elm$core$Basics$round((y / image.au) * renderedImage.au)
		};
	});
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Plans$physicalLocationView = F5(
	function (translations, renderedImage, image, persisted, physicalLocation) {
		var position = physicalLocation.a;
		var object = physicalLocation.b;
		var wrapper = persisted ? $author$project$Plans$objectDnD.ft(
			$author$project$Plans$DraggedPhysicalLocation(physicalLocation)) : $elm$html$Html$div;
		var scaledPosition = A3($author$project$Plans$scaleCoordinates, renderedImage, image, position);
		var content = function () {
			if (!object.$) {
				var meterId = object.a;
				var name = object.b;
				var energy = object.c;
				var meterUrl = A3(
					$elm_community$basics_extra$Basics$Extra$flip,
					$author$project$View$localizeUrl,
					$author$project$Enectiva$I18n$locale(translations),
					'/meters/' + ($elm$core$String$fromInt(meterId) + '/edit'));
				return _List_fromArray(
					[
						$author$project$Plans$meterIcon(energy),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Plans$objectDetailClass,
								$elm$html$Html$Attributes$class('group-hover:block')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$target('blank_'),
										$elm$html$Html$Attributes$href(meterUrl)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]))
							]))
					]);
			} else {
				var dsId = object.a;
				var name = object.b;
				var dp = object.c;
				var dsUrl = A3(
					$elm_community$basics_extra$Basics$Extra$flip,
					$author$project$View$localizeUrl,
					$author$project$Enectiva$I18n$locale(translations),
					'/data_series/' + ($elm$core$String$fromInt(dsId) + '/edit'));
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex'),
								$elm$html$Html$Attributes$class('group-hover:shadow-md')
							]),
						_List_fromArray(
							[
								A2($author$project$Plans$dsIconWithValueBanner, translations, dp)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[$author$project$Plans$objectDetailClass]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$target('blank_'),
										$elm$html$Html$Attributes$href(dsUrl)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]))
							]))
					]);
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('absolute pin-l pin-t group'),
					$elm$html$Html$Attributes$class('z-10 hover:z-20'),
					A2(
					$elm$html$Html$Attributes$style,
					'margin-left',
					$author$project$Types$px(scaledPosition.hb)),
					A2(
					$elm$html$Html$Attributes$style,
					'margin-top',
					$author$project$Types$px(scaledPosition.hc - renderedImage.au))
				]),
			_List_fromArray(
				[
					A2(
					wrapper,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cursor-move group')
						]),
					_Utils_ap(
						content,
						_List_fromArray(
							[
								$author$project$Spinner$overlay(!persisted)
							])))
				]));
	});
var $author$project$Plans$planView = F4(
	function (translations, objectMove, imageDimensions, _v0) {
		var name = _v0.f9;
		var image = _v0.T;
		var physicalLocations = _v0.K;
		var provisionalPhysicalLocations = _v0.U;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'max-width',
					$author$project$Types$px(image.bn))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id($author$project$Plans$planId),
							$elm$html$Html$Attributes$src(image.g3),
							$elm$html$Html$Attributes$title(
							$author$project$Enectiva$ValidatedValue$value(name)),
							A2(
							$elm$html$Html$Events$on,
							'load',
							$elm$json$Json$Decode$succeed($author$project$Plans$FloorPlanImageLoaded)),
							$elm$html$Html$Attributes$class('border border-solid border-grey-300 w-full border-box')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('relative')
						]),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							A4($author$project$Plans$physicalLocationView, translations, imageDimensions, image, true),
							physicalLocations),
						A2(
							$elm$core$List$map,
							A4($author$project$Plans$physicalLocationView, translations, imageDimensions, image, false),
							provisionalPhysicalLocations))),
					A2(
					$author$project$Enectiva$View$viewIf,
					function (_v1) {
						return A3(
							$author$project$Plans$objectDnD.fv,
							$author$project$Plans$OnPlan,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative w-full'),
									A2($elm$html$Html$Attributes$style, 'z-index', '5'),
									A2(
									$elm$html$Html$Attributes$style,
									'height',
									$author$project$Types$px(imageDimensions.au)),
									A2(
									$elm$html$Html$Attributes$style,
									'margin-bottom',
									$author$project$Types$px(-imageDimensions.au)),
									A2(
									$elm$html$Html$Attributes$style,
									'top',
									$author$project$Types$px((-imageDimensions.au) - 5))
								]),
							_List_Nil);
					},
					$author$project$DnD$anythingDragged(objectMove))
				]));
	});
var $author$project$Plans$mainView = F4(
	function (translations, objectMove, imageDimensions, floorPlan) {
		switch (floorPlan.$) {
			case 0:
				var fp = floorPlan.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							$author$project$Plans$headerView(
							_List_fromArray(
								[
									A2($author$project$Plans$floorPlanName, translations, fp),
									A2($author$project$Plans$deleteFloorPlanButton, translations, fp)
								])),
							A4($author$project$Plans$planView, translations, objectMove, imageDimensions, fp)
						]),
					_List_fromArray(
						[
							$author$project$Plans$objectBeingMoved(objectMove)
						]));
			case 1:
				var deleteRequest = floorPlan.a;
				var fp = floorPlan.b;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							$author$project$Plans$headerView(
							_List_fromArray(
								[
									A2($author$project$Plans$floorPlanName, translations, fp),
									A2($author$project$Plans$deleteFloorPlanButton, translations, fp)
								])),
							A4($author$project$Plans$planView, translations, objectMove, imageDimensions, fp)
						]),
					_List_fromArray(
						[
							function () {
							switch (deleteRequest.$) {
								case 0:
									return A2($author$project$Plans$deleteConfirmationView, translations, fp.fM);
								case 1:
									return $author$project$Spinner$overlay(true);
								case 2:
									return $author$project$Plans$deletionErrorView;
								default:
									return $author$project$Enectiva$View$nothing;
							}
						}()
						]));
			default:
				var fp = floorPlan.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[
							A2($author$project$Plans$imageUploadView, translations, fp)
						]),
					_List_Nil);
		}
	});
var $author$project$SelectionState$NotSelected = 1;
var $author$project$Plans$notSelected = function (a) {
	return _Utils_Tuple2(1, a);
};
var $author$project$Plans$orderSaveError = function (order) {
	if (order.$ === 2) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-red-800 text-center p-2')
				]),
			$elm$core$List$singleton(
				$elm$html$Html$text('saving error')));
	} else {
		return $author$project$Enectiva$View$nothing;
	}
};
var $author$project$Plans$orderSaveSpinner = function (order) {
	if (order.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-16 w-full p-2'),
					$author$project$Spinner$container
				]),
			_List_fromArray(
				[
					$author$project$Spinner$overlay(true)
				]));
	} else {
		return $author$project$Enectiva$View$nothing;
	}
};
var $author$project$Plans$OutsideOfPlan = function (a) {
	return {$: 1, a: a};
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Keyed$ul = $elm$html$Html$Keyed$node('ul');
var $author$project$Types$energyToString = function (energy) {
	switch (energy) {
		case 1:
			return 'el';
		case 2:
			return 'ga';
		case 3:
			return 'wa';
		case 4:
			return 'he';
		case 5:
			return 'co';
		case 6:
			return 'hca';
		case 7:
			return 'lf';
		default:
			return '';
	}
};
var $author$project$Plans$unplacedObjectView = function (_v0) {
	var persisted = _v0.a;
	var object = _v0.b;
	var wrapper = persisted ? A2(
		$author$project$Plans$objectDnD.ft,
		$author$project$Plans$DraggedObject(object),
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cursor-move flex items-center mb-2')
			])) : $elm$html$Html$div(
		_List_fromArray(
			[$author$project$Spinner$container]));
	var _v1 = function () {
		if (!object.$) {
			var id = object.a;
			var name = object.b;
			var energy = object.c;
			return _Utils_Tuple2(
				'm' + $elm$core$String$fromInt(id),
				_List_fromArray(
					[
						$author$project$Plans$meterIcon(energy),
						$elm$html$Html$text(
						$author$project$Types$energyToString(energy) + (' ' + name))
					]));
		} else {
			var id = object.a;
			var name = object.b;
			return _Utils_Tuple2(
				'ds' + $elm$core$String$fromInt(id),
				_List_fromArray(
					[
						$author$project$Plans$dsIcon,
						$elm$html$Html$text(name)
					]));
		}
	}();
	var htmlId = _v1.a;
	var content = _v1.b;
	return _Utils_Tuple2(
		htmlId,
		A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					wrapper(
					_Utils_ap(
						content,
						_List_fromArray(
							[
								$author$project$Spinner$overlay(!persisted)
							])))
				])));
};
var $author$project$Plans$unplacedObjectsViewHelp = F3(
	function (active, id, unplacedObjects) {
		var wrapper = active ? $author$project$Plans$objectDnD.fv(
			$author$project$Plans$OutsideOfPlan(id)) : $elm$html$Html$div;
		return A2(
			wrapper,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-4 border-dashed border-transparent border-box rounded fast-colors-transition'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('border-grey-400 hover:border-grey-600', active)
						])),
					A2($elm$html$Html$Attributes$style, 'grid-area', 'unplaced'),
					A2($elm$html$Html$Attributes$style, 'z-index', '5')
				]),
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$Keyed$ul,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Plans$unplacedObjectView, unplacedObjects))));
	});
var $author$project$Plans$unplacedObjectsView = F3(
	function (floorPlan, active, unplacedObjects) {
		switch (floorPlan.$) {
			case 2:
				return $author$project$Enectiva$View$nothing;
			case 0:
				var id = floorPlan.a.fM;
				return A3($author$project$Plans$unplacedObjectsViewHelp, active, id, unplacedObjects);
			default:
				var id = floorPlan.b.fM;
				return A3($author$project$Plans$unplacedObjectsViewHelp, false, id, unplacedObjects);
		}
	});
var $author$project$Plans$view = function (_v0) {
	var state = _v0.b4;
	var translations = _v0.S;
	var _v1 = A4(
		$author$project$Plans$mainView,
		translations,
		state.bc,
		state.cw,
		$author$project$SelectList$selected(state.f));
	var mainPlanView = _v1.a;
	var overlays = _v1.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('plans')
			]),
		_Utils_ap(
			overlays,
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid plans-grid gap-x-4 gap-y-2')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'grid-area', 'navigation')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Plans$floorPlanListView,
									translations,
									$elm$core$Maybe$Just(state.ad),
									A3(
										$author$project$Plans$floorPlansToList,
										$author$project$Plans$notSelected,
										$elm$core$Tuple$pair(0),
										state.f)),
									$author$project$Plans$floorPlanBeingMoved(state.ad),
									$author$project$Plans$orderSaveError(state.ad),
									$author$project$Plans$orderSaveSpinner(state.ad)
								])),
						_Utils_ap(
							mainPlanView,
							_List_fromArray(
								[
									A3(
									$author$project$Plans$unplacedObjectsView,
									$author$project$SelectList$selected(state.f),
									!_Utils_eq(
										$author$project$DnD$getDragMeta(state.bc),
										$elm$core$Maybe$Nothing),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											$elm$core$Tuple$pair(true),
											state.ai),
										A2(
											$elm$core$List$map,
											$elm$core$Tuple$pair(false),
											state.aV)))
								])))))));
};
var $author$project$Plans$main = $elm$browser$Browser$element(
	{
		h$: A2(
			$elm$core$Basics$composeR,
			$author$project$Plans$init,
			$elm$core$Tuple$mapFirst($author$project$Plans$ValidModel)),
		gT: function (m) {
			if (!m.$) {
				var model = m.a;
				return $author$project$Plans$subscriptions(model);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		i4: F2(
			function (msg, m) {
				if (!m.$) {
					var model = m.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Plans$ValidModel,
						A2($author$project$Plans$update, msg, model));
				} else {
					return $author$project$Enectiva$Util$noCmd(m);
				}
			}),
		i6: function (m) {
			if (!m.$) {
				var model = m.a;
				return $author$project$Plans$view(model);
			} else {
				var err = m.a;
				return $elm$html$Html$text(err);
			}
		}
	});
/*
_Platform_export({'Plans':{'init':$author$project$Plans$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (unplacedObjects) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (translations) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (locale) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (floorPlans) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (entityId) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (csrfToken) {
													return $elm$json$Json$Decode$succeed(
														{as: csrfToken, bu: entityId, f: floorPlans, eg: locale, S: translations, ai: unplacedObjects});
												},
												A2($elm$json$Json$Decode$field, 'csrfToken', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'entityId', $elm$json$Json$Decode$int));
								},
								A2($elm$json$Json$Decode$field, 'floorPlans', $elm$json$Json$Decode$value));
						},
						A2($elm$json$Json$Decode$field, 'locale', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'translations', $elm$json$Json$Decode$value));
		},
		A2($elm$json$Json$Decode$field, 'unplacedObjects', $elm$json$Json$Decode$value)))(0)}});}(this));
*/
export const Elm = {'Plans':{'init':$author$project$Plans$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (unplacedObjects) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (translations) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (locale) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (floorPlans) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (entityId) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (csrfToken) {
													return $elm$json$Json$Decode$succeed(
														{as: csrfToken, bu: entityId, f: floorPlans, eg: locale, S: translations, ai: unplacedObjects});
												},
												A2($elm$json$Json$Decode$field, 'csrfToken', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'entityId', $elm$json$Json$Decode$int));
								},
								A2($elm$json$Json$Decode$field, 'floorPlans', $elm$json$Json$Decode$value));
						},
						A2($elm$json$Json$Decode$field, 'locale', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'translations', $elm$json$Json$Decode$value));
		},
		A2($elm$json$Json$Decode$field, 'unplacedObjects', $elm$json$Json$Decode$value)))(0)}};
  